(function () {
  'use strict';
  angular
    .module('ai.simonCommonUi', ['thirdPartyLibraries']);
})();

/**
 * Created by Luiz on 09/02/2017.
 */
//TODO: Review this, has a lot of duplicated code

(function () {
  'use strict';
  angular
    .module('ai.simonCommonUi')
    .directive('labelInput', labelInputDirective);

  function labelInputDirective($timeout) {
    return {
      restrict: 'E',
      scope: {
        ngModel: '=',
        saveCallback: '=?',
        labelType: '=?',
        parameterSaveCallback: '=?',
        cancelCallback: '=?',
        hideLabel: '=?',
        isInitialModeInEdit: '=?'
      },
      templateUrl: 'directives/label-input/label-input.directive.html',
      link: function (scope, element, attr, ngModelController) {
        scope.adaptTextAreaHeight = function () {
          $timeout(function () {
            var textarea = $(element).find('.textarea-c.not-hide-label textarea');
            textarea[0].style.height = '0px';

            var contentHeight = textarea[0].scrollHeight;
            textarea[0].style.height = contentHeight + 'px';
          }, 100);
        };

        scope.lastChangedValue = angular.copy(scope.ngModel);

        scope.edit = function () {
          scope.isEditing = true;
          scope.lastChangedValue = angular.copy(scope.ngModel);

          if (scope.labelType == 'textarea') {
            scope.adaptTextAreaHeight();
          } else {
            setTimeout(function () {
              var input = $(element[0]).find('input')[0];
              input.select();
            }, 100);
          }
        };

        scope.ok = function () {
          scope.isEditing = false;

          //adapt textarea height
          if (scope.labelType == 'textarea') {
            scope.adaptTextAreaHeight();
          }

          if (scope.parameterSaveCallback) {
            if (scope.saveCallback) {scope.saveCallback(scope.parameterSaveCallback);}
          } else {
            if (scope.saveCallback) {scope.saveCallback();}
          }
        };

        scope.autoSave = function autoSave() {
          $timeout(function () {
            scope.ok();
          }, 1000);
        };

        scope.cancel = function (event) {
          scope.isEditing = false;
          scope.ngModel = angular.copy(scope.lastChangedValue);

          //adapt textarea height
          if (scope.labelType === 'textarea') {
            scope.adaptTextAreaHeight();
          }

          if (scope.parameterSaveCallback) {
            if (scope.cancelCallback) {scope.cancelCallback(scope.parameterSaveCallback);}
          } else {
            if (scope.cancelCallback) {scope.cancelCallback();}
          }
        };

        scope.isEditing = scope.isInitialModeInEdit;

        //adapt textarea height
        if (scope.labelType === 'textarea') {
          $timeout(function () {
            var textarea = $(element).find('.textarea-c textarea');

            textarea.on('keydown', function (e) {
              if (e.keyCode === 13) {
                if (!e.ctrlKey && !e.shiftKey && !e.altKey) {
                  scope.ok();
                  textarea.blur();
                } else if (e.ctrlKey || e.altKey) {
                  $(this).val(function (i, val) {
                    return val + '\n';
                  });
                }
              }
              if (e.keyCode === 27) {
                scope.cancel();
                textarea.blur();
              }
            });

            scope.adaptTextAreaHeight();
          }, 100);
        }

        if (scope.labelType !== 'textarea') {
          $timeout(function () {
            var input = $(element).find('input');

            input.on('keydown', function (e) {
              if (e.keyCode === 13) {
                scope.ok();
                input.blur();
              }
            });
          }, 100);
        }

      }
    };
  }

})();

(function () {
  'use strict';
  angular
    .module('ai.simonCommonUi')
    .directive('editableContent', function ($timeout) {
      return {
        require: 'ngModel',
        link: function (scope, element, attrs, ngModel) {

          function read() {
            ngModel.$setViewValue(element[0].innerText);
          }

          ngModel.$render = function () {
            element.html(ngModel.$viewValue || '');
          };

          element.bind('keypress', function (e) {
            var keyCode = (e.keyCode ? e.keyCode : e.which);
            return keyCode !== 13;
          });

          element.bind('keyup', function (e) {
            var keyCode = (e.keyCode ? e.keyCode : e.which);
            if (keyCode === 13 || keyCode === 27) {
              scope.$apply(read);
              element.blur();
            }
          });

          element.bind('input', function (e) {
            var maxNumberOfChars = 60;
            if (element[0].innerText.length > maxNumberOfChars) {
              element[0].innerText = element[0].innerText.substring(0, maxNumberOfChars);
              setEndOfContenteditable(element[0]);
            }
          });

          element.bind('blur', function () {
            $timeout(function () {
              element.attr('spellcheck', false);
            });
            scope.$apply(read);
          });

          element.bind('focus', function () {
            $timeout(function () {
              element.attr('spellcheck', true);
              document.execCommand('selectAll', false, null)
            });
          });

          function setEndOfContenteditable(contentEditableElement) {
            var range, selection;
            if (document.createRange) { //Firefox, Chrome, Opera, Safari, IE 9+
              range = document.createRange();//Create a range (a range is a like the selection but invisible)
              range.selectNodeContents(contentEditableElement);//Select the entire contents of the element with the range
              range.collapse(false);//collapse the range to the end point. false means collapse to end rather than the start
              selection = window.getSelection();//get the selection object (allows you to change selection)
              selection.removeAllRanges();//remove any selections already made
              selection.addRange(range);//make the range you have just created the visible selection
            } else if (document.selection) {  //IE 8 and lower
              range = document.body.createTextRange();//Create a range (a range is a like the selection but invisible)
              range.moveToElementText(contentEditableElement);//Select the entire contents of the element with the range
              range.collapse(false);//collapse the range to the end point. false means collapse to end rather than the start
              range.select();//Select the range (make it the visible selection
            }
          }
        }
      };
    });
})();


(function () {
  'use strict';

  angular
    .module('ai.simonCommonUi')
    .component('waveSurfer', {
      bindings: {
        waveSurferInstance: '=',
        waveSurferOptions: '<',
        bookmarksInSeconds: '<',
        waveAudioUrl: '@',
        wavePeaks: '<',
        timeCodeOffset: '<'
      },
      controller: WaveSurferController,
      templateUrl: 'components/wave-surfer/wave-surfer.component.html'
    });

  WaveSurferController.$inject = ['$element', '$filter', '$rootScope', '$timeout'];

  function WaveSurferController($element, $filter, $rootScope, $timeout) {
    var me = this;

    var defaultRegionColor = 'hsla(25, 100%, 92%, 0.6)';
    var onForceResize;

    me.$onInit = init;
    me.$onChanges = onChanges;
    me.$onDestroy = onDestroy;
    me.getPointedTime = getPointedTime;
    me.getCurrentTime = getCurrentTime;
    me.getRemainingTime = getRemainingTime;


    me.waveFormContainerStyle = {};
    me.isLoaded = false;

    function init() {
      hideWaveForm();
      adjustRemainingTimePosition();
      subscribeToEvents();
    }

    function onChanges(changesObj) {
      if (changesObj.waveSurferOptions && me.waveSurferOptions) {
        me.waveFormOverlayStyle = {
          height: me.waveSurferOptions.height + 'px'
        };
        me.waveSurferOptions.container = '#waveFormForTranscription';
        me.waveSurferInstance = WaveSurfer.create(me.waveSurferOptions);
        me.waveSurferInstance.backend.setVolume(0);
        me.waveSurferInstance.setMute(true);
      }

      if (changesObj.bookmarksInSeconds && me.isLoaded) {
        drawBookmarks();
      }
      if (changesObj.waveAudioUrl) {
        me.isLoaded = false;
        hideWaveForm();
        if (me.waveAudioUrl) {
          me.waveSurferInstance.load(me.waveAudioUrl, me.wavePeaks);
        }
      }
    }

    function onDestroy() {
      unsubscribeFromEvents();
      me.waveSurferInstance.destroy();
      me.waveSurferInstance = null;
    }

    function hideWaveForm() {
      me.waveFormContainerStyle.visibility = 'hidden';
      me.waveFormContainerStyle.marginTop = '-' + me.waveSurferOptions.height + 'px';
    }

    function showWaveForm() {
      me.waveFormContainerStyle.visibility = 'visible';
      me.waveFormContainerStyle.marginTop = 0;
    }

    function adjustRemainingTimePosition() {
      $timeout(function () {
        var remainingTimeElement = $($element).find('.remaining-time');
        var currentTimeElement = $($element).find('.current-time');

        var waveFormContainerElement = $($element).find('.wave-form-container');
        var rightPosition = $(window).width() - (waveFormContainerElement.offset().left + waveFormContainerElement.outerWidth());

        var displayElement = $($element).find('.display-time');
        var marginTop = waveFormContainerElement.outerHeight() - displayElement.outerHeight() - 1;

        remainingTimeElement.css('right', rightPosition + 'px');
        remainingTimeElement.css('marginTop', marginTop + 'px');
        currentTimeElement.css('marginTop', marginTop + 'px');
      });
    }

    function isLastTranscriptRow(bookmark) {
      return Math.floor(bookmark.end) === Math.floor(getWaveSurferDuration());
    }

    function drawBookmarks() {
      me.waveSurferInstance.clearRegions();
      if (angular.isArray(me.bookmarksInSeconds)) {
        me.bookmarksInSeconds.forEach(function (bookmark) {
          var region = {
            start: bookmark.start,
            end: isLastTranscriptRow(bookmark) ? getWaveSurferDuration() : bookmark.end,
            drag: false,
            resize: false,
            color: defaultRegionColor
          };
          me.waveSurferInstance.addRegion(region);
        });
      }
    }

    function getTimecodeInSeconds() {
      var timeCodeOffset = me.timeCodeOffset;
      if (timeCodeOffset) {
        timeCodeOffset = moment.duration(timeCodeOffset).asSeconds();
      } else {
        timeCodeOffset = 0;
      }
      return timeCodeOffset;
    }

    function getWaveSurferDuration() {
      if (me.waveSurferInstance) {
        return me.waveSurferInstance.getDuration();
      }
      return 0;
    }

    function getWaveSurferCurrentTime() {
      if (me.waveSurferInstance) {
        return me.waveSurferInstance.getCurrentTime();
      }
      return 0;
    }

    function getPointedTime(percentage) {
      return $filter('secondsToTime')(getTimecodeInSeconds() + (percentage * getWaveSurferDuration()));
    }

    function getCurrentTime() {
      return $filter('secondsToTime')(getTimecodeInSeconds() + getWaveSurferCurrentTime());
    }

    function getRemainingTime() {
      return $filter('secondsToTime')(getTimecodeInSeconds() + (getWaveSurferDuration() - getWaveSurferCurrentTime()));
    }

    function subscribeToEvents() {
      var lastRegionIn;
      onForceResize = $rootScope.$on('waveform.resize', function (event, data) {
        $timeout(function () {
          resizer();
        });
      });
      startListeningResizing();

      me.waveSurferInstance.on('ready', function () {
        $timeout(function () {
          me.isLoaded = true;
          showWaveForm();
          me.waveSurferInstance.backend.setVolume(0);
          me.waveSurferInstance.setMute(true);
          drawBookmarks();
        });
      });

      me.waveSurferInstance.on('region-in', function (region) {
        if (!lastRegionIn || lastRegionIn.start !== region.start) {
          drawBookmarks();
          lastRegionIn = region;
        }
      });

      me.waveSurferInstance.on('region-out', function () {
        drawBookmarks();
      });

      me.waveSurferInstance.on('seek', function () {
        drawBookmarks();
      });
    }

    function unsubscribeFromEvents() {
      onForceResize();
      finishListeningResizing();
    }


    function resizer() {
      me.waveSurferInstance.empty();
      me.waveSurferInstance.drawBuffer();
      drawBookmarks();
      adjustRemainingTimePosition();
    }

    function startListeningResizing() {
      $(window).resize(resizer);
    }

    function finishListeningResizing() {
      $(window).off('resize', resizer);
    }
  }

})();


(function () {
    'use strict';

    angular
        .module('ai.simonCommonUi')
        .component('simonHeader', {
            controller: SimonHeaderController,
            bindings: {
                user: '<',
                isPublicPageView: '<',
                menuItemList: '<',
                logoLinkHref: '@',
                onMenuItemClick: '&',
                onLogout: '&',
                onLogin: '&',
                whitelabel: '<'
            },
            templateUrl: 'components/simon-header/simon-header.component.html',
            transclude: true,
        });

    SimonHeaderController.$inject = [
        'domHelperService'
    ];

    function SimonHeaderController(domHelperService) {
        var me = this;

        me.$onInit = onInit;
        me.logout = logout;
        me.getAvatarPath = getAvatarPath;
        me.inIframe = domHelperService.inIframe;

        function onInit() {
        }

        function logout() {
            if (angular.isFunction(me.onLogout)) {
                me.onLogout();
            }
        }

        function getAvatarPath() {
            var defaultAvatarImage = '../img/default_avatar.png';
            if (me.user) {
                return me.user.avatar || defaultAvatarImage;
            }
            return defaultAvatarImage;
        }


    }
})();

(function () {
  'use strict';

  angular
    .module('ai.simonCommonUi')
    .component('projectTranscripts', {
      controller: ProjectTranscriptsController,
      bindings: {
        isStickyActive: '=',
        hideHome: '<',
        project: '<',
        medias: '<',
        currentMedia: '<',
        transcriptions: '<',
        isProjectPublished: '<',
        isCurrentMediaLockByOtherUser: '<',
        isProjectShared: '<',
        isNoWebsiteApp: '<',
        user: '<',
        isTeamMember: '<',
        isProjectOwner: '<',
        isAdmin: '<',
        endTimeForTranscribing: '<',
        isPublicPageView: '<',
        waveSoundOptions: '<',
        hideShareButton: '<',
        hideTimecodeButton: '<',
        languageTextDirection: '@',
        islanguageTextDirectionRTL: '@',
        onClickShareButton: '&',
        onClickExportButton: '&',
        onProjectChange: '&',
        onProjectFpsChange: '&',
        onProjectTranscribed: '&',
        onMediaSelect: '&',
        onMediaChange: '&',
        forceLock: '&',
        onTranscriptionChange: '&',
        onTranscriptionAdd: '&',
        onTranscriptionDelete: '&',
        onSpeakerAdd: '&',
        onSpeakerDelete: '&',
        onSpeakerUpdate: '&',
        onClickHome: '&',
        scrollContainerSelector: '@',
        scrollContainerOffset: '<',
        onClickMergeTracksButton: '&',
        whitelabel: '<'
      },
      templateUrl: 'components/project-transcripts/project-transcripts.component.html'
    });

  ProjectTranscriptsController.$inject = [
    '$filter',
    '$interval',
    '$rootScope',
    '$sce',
    '$timeout',
    '$window',
    'PROJECT_TRANSCRIBING_SHORTCUTS',
    'SPEAKER_COLORS',
    'domHelperService',
    'fileHelperService',
    'smartCommandsService',
    'ssStorageService',
    'whitelabel'
  ];

  function ProjectTranscriptsController(
    $filter,
    $interval,
    $rootScope,
    $sce,
    $timeout,
    $window,
    PROJECT_TRANSCRIBING_SHORTCUTS,
    SPEAKER_COLORS,
    domHelperService,
    fileHelperService,
    smartCommandsService,
    ssStorageService,
    whitelabel
  ) {
    var me = this;

    var lastReachedAutoScrollYPosition;
    var isAutomaticScrollExecuting;

    var previousSearchInputOpenState = false;
    var oldVideoFilePath;
    var lastProjectStatus;

    var decimalSecondsInterval;

    var addedTranscriptionListener;

    var createdSpeakerListener;
    var deletedSpeakerListener;
    var updatedSpeakerListener;

    var scrollElementContainer = $window;

    me.$onInit = onInit;
    me.$onDestroy = onDestroy;
    me.$onChanges = onChanges;
    me.$doCheck = doCheck;

    me.playPauseVideo = playPauseVideo;
    me.onUpdateVideoTime = onUpdateVideoTime;
    me.getFrameSeparatorString = getFrameSeparatorString;
    me.onSelectMedia = onSelectMedia;
    me.setVideo = setVideo;
    me.canExportProject = canExportProject;
    me.canExportCurrentMedia = canExportCurrentMedia;
    me.isCurrentMediaTranslating = isCurrentMediaTranslating;
    me.isCurrentMediaTranscribing= isCurrentMediaTranscribing;
    me.inIframe = domHelperService.inIframe;

    me.goToPreviousTranscription = goToPreviousTranscription;
    me.goToNextTranscription = goToNextTranscription;
    me.changePlaySpeed = changePlaySpeed;
    me.playTime = playTime;
    me.playWordTime = playWordTime;
    me.isPlaying = isPlaying;
    me.getFormattedTimestamp = getFormattedTimestamp;
    me.onStartAutoScroll = onStartAutoScroll;
    me.onFinishAutoScroll = onFinishAutoScroll;
    me.onTranscriptionWordsChange = onTranscriptionWordsChange;
    me.onTranscriptionWordsCreate = onTranscriptionWordsCreate;
    me.onTranscriptionWordsRemove = onTranscriptionWordsRemove;
    me.getCurrentMediaIndex = getCurrentMediaIndex;
    me.goToPreviousTranscriptFile = goToPreviousTranscriptFile;
    me.goToNextTranscriptFile = goToNextTranscriptFile;
    me.toggleVolumeState = toggleVolumeState;
    me.bookmarkCurrentTranscription = bookmarkCurrentTranscription;
    me.getTimeInBar = getTimeInBar;
    me.onTimerStarted = onTimerStarted;
    me.onTimerFinished = onTimerFinished;
    me.isScrollAtTheBottom = domHelperService.isScrollAtTheBottom;
    me.isIOS = $window.isIOS;
    me.setLanguageRegionCode = setLanguageRegionCode;
    me.onPlayerReady = onPlayerReady;
    me.onUpdateState = onUpdateState;
    me.onUpdateVolume = onUpdateVolume;

    me.updateMediaSpeaker = updateMediaSpeaker;
    me.getNoSpeakerSymbol = getNoSpeakerSymbol;

    me.canMergeTracks = canMergeTracks;
    me.WhiteList = whitelabel

    me.API = null;
    me.sources = [];

    me.config = {
      autoHide: true,
      autoHideTime: 3000,
      autoPlay: false,
      plugins: {
        cuepoints: {
          points: []
        }
      },
      playbackSpeeds: ['0.5', '0.75', '1', '1.5', '2']
    };

    me.applyFrameRateToAllProject = false;

    me.userSearch = {
      value: ''
    };
    me.newSpeaker = {};
    me.popoverTimecode = {};
    me.popoverTimecodeForMobile = {};
    me.mediaTimecode = {time: null, frames: null};
    me.openPopoverAnnotations = {};
    me.popovers = {timecode: false, search: false};
    me.showOnlyBookmarks = false;
    me.showOnlyAnnotations = false;
    me.isAutoScrollActive = true;

    me.searchInput = {
      isOpen: false
    };

    me.frameRateOptions = [23.976, 24, 25, 29.97, 30, 50, 59.94, 60];

    me.showVideo = true;

    me.trackState = {
      isPlaying: false,
      playSpeed: '1'
    };

    me.countdownDecimalSeconds = '999';

    function onInit() {
      setLanguageRegionCode();
      lastProjectStatus = me.project.status;

      if (me.scrollContainerSelector) {
        scrollElementContainer = angular.element(me.scrollContainerSelector)[0];
        scrollElementContainer = scrollElementContainer || $window;
      }

      me.waveSurfer = {
        instance: null,
        options: {
          height: 60,
          waveColor: me.waveSoundOptions && me.waveSoundOptions.waveColor ? me.waveSoundOptions.waveColor : '#BAA6CB',
          progressColor: me.waveSoundOptions && me.waveSoundOptions.progressColor ? me.waveSoundOptions.progressColor : '#7e56a2',
          backend: 'MediaElement'
        }
      };

      smartCommandsService.unpause();
      smartCommandsService.deleteDefaultCheatSheetShortcut();

      if (me.project && me.project.status === 'transcribing') {
        initCountdownDecimalSeconds();
      }

      subscribeToEvents();
    }

    function setLanguageRegionCode() {
      me.islanguageTextDirectionRTL = "ltr";

      var langugeRegionCodeListRTL = ['ar', 'he', 'fa', 'ur'];
      var langugeTranslatedRTL = [3, 25, 44, 62];
      if (me.currentMedia.status==='translated') {
        if (langugeTranslatedRTL.includes(me.currentMedia.translateTargetLanguageId))
          me.islanguageTextDirectionRTL = "rtl";
      }
      else {
        var currentLanguageCode = ssStorageService.get('languageRegionCode');
        if (currentLanguageCode) {
          var captionCode = currentLanguageCode.split("-")[0];
          var isRTL = langugeRegionCodeListRTL.includes(captionCode);
          if(isRTL)
            me.islanguageTextDirectionRTL = "rtl";
        }
      }
    }

    function onChanges(changes) {
      if (changes.medias && changes.medias.currentValue && changes.medias.currentValue.length) {
        handleMediasChange();
      }

      if (changes.currentMedia && changes.currentMedia.currentValue) {
        showMediaTranscriptions(me.currentMedia);
        setMediaSpeakers(me.currentMedia);
        syncRenderingWaveForm();

        var mediaIndex = me.medias.findIndex(function (media) {
          return media.id === me.currentMedia.id;
        });

        if (mediaIndex !== -1) {
          updateMediaSources(mediaIndex);
        }

        onSelectMedia(me.currentMedia);
      }

      if (changes.transcriptions && changes.transcriptions.currentValue) {
        var transcriptions = me.transcriptions.map(function (transcription) {
          return addUIPropertiesToTranscription(transcription);
        });

        me.transcriptions = _.filter(transcriptions, function (transcriptionItem) {
          return !_.isNil(transcriptionItem.startTime);
        });

        me.updateCuePoints();
      }
    }

    function doCheck() {
      if (previousSearchInputOpenState !== me.searchInput.isOpen) {
        previousSearchInputOpenState = me.searchInput.isOpen;
        if (!me.searchInput.isOpen) {
          $rootScope.$broadcast('forceResizeElement');
        }
      }

      if (me.currentMedia && me.currentMedia.videoFilePath && oldVideoFilePath !== me.currentMedia.videoFilePath) {
        updatePlayerInfo(me.currentMedia);
        oldVideoFilePath = me.currentMedia.videoFilePath;
      }

      if (me.project && me.project.status && lastProjectStatus !== me.project.status) {
        if (me.project.status === 'ready') {
          $interval.cancel(decimalSecondsInterval);
          if (lastProjectStatus !== 'ready') {
            me.onProjectTranscribed();
          }
        }

        lastProjectStatus = me.project.status;
      }
    }

    function onDestroy() {
      unsubscribeFromEvents();
    }

    function syncRenderingWaveForm() {
      me.showWaveSurfer = true;
    }

    function subscribeToEvents() {
      smartCommandsService.preventSpaceKeyBoard(true, ['overlayPlayContainer']);

      smartCommandsService.bind(PROJECT_TRANSCRIBING_SHORTCUTS.PLAY_PAUSE, function (e) {
        e.preventDefault();
        // TODO: find another way to do that in order to avoid dom manipulation here in the controller
        // When you are hovering the videoPlayer
        if (!$(e.target).hasClass('overlayPlayContainer')) {
          playPauseVideo();
        }
      });
      smartCommandsService.bind(PROJECT_TRANSCRIBING_SHORTCUTS.REWIND, function (e) {
        e.preventDefault();
        addTimeVideo(-5);
      });
      smartCommandsService.bind(PROJECT_TRANSCRIBING_SHORTCUTS.FAST_FORWARD, function (e) {
        e.preventDefault();
        addTimeVideo(5);
      });
      smartCommandsService.bind(PROJECT_TRANSCRIBING_SHORTCUTS.PREVIOUS_TRANSCRIPTION, function (e) {
        e.preventDefault();
        goToPreviousTranscription(false);
      });
      smartCommandsService.bind(PROJECT_TRANSCRIBING_SHORTCUTS.NEXT_TRANSCRIPTION, function (e) {
        e.preventDefault();
        goToNextTranscription(false);
      });
      smartCommandsService.bind(PROJECT_TRANSCRIBING_SHORTCUTS.BOOKMARK, function (e) {
        e.preventDefault();
        bookmarkCurrentTranscription();
      });
      smartCommandsService.bind(PROJECT_TRANSCRIBING_SHORTCUTS.SPEED_UP_PLAYBACK, function (e) {
        e.preventDefault();
        changePlaySpeed(false, false);
      });
      smartCommandsService.bind(PROJECT_TRANSCRIBING_SHORTCUTS.SLOW_DOWN_PLAYBACK, function (e) {
        e.preventDefault();
        changePlaySpeed(false, true);
      });

      smartCommandsService.bind(PROJECT_TRANSCRIBING_SHORTCUTS.NEW_PARAGRAPH, function () {
      });
      smartCommandsService.bind(PROJECT_TRANSCRIBING_SHORTCUTS.NEW_ROW, function () {
      });
      smartCommandsService.bind(PROJECT_TRANSCRIBING_SHORTCUTS.GO_TO_WORD_TIMECODE, function () {
      });

      addedTranscriptionListener = $rootScope.$on('projectTranscripts.addedTranscription', function (event, data) {
        if (me.currentMedia && me.currentMedia.id === data.mediaId) {
          addTranscription(data.transcription, data.autoFocus, data.indexToInsertNewTranscription);
          me.updateCuePoints();
        }
      });

      createdSpeakerListener = $rootScope.$on('projectTranscripts.createdSpeaker', function (event, data) {
        if (me.currentMedia && me.currentMedia.id === data.mediaId) {
          me.newSpeaker.name = '';
          me.newSpeaker.color = '';
          me.currentMedia.speakers.push(data.createdSpeaker);
          setMediaSpeakers(me.currentMedia);
          me.setTranscriptionSpeaker(data.transcription, data.createdSpeaker);
        }
      });

      deletedSpeakerListener = $rootScope.$on('projectTranscripts.deletedSpeaker', function (event, data) {
        if (me.currentMedia && me.currentMedia.id === data.mediaId) {
          angular.forEach(me.transcriptions, function (transcription) {
            if (transcription.speaker && data.speakerToDeleteId === transcription.speaker.id) {
              transcription.speaker = null;
            }
            if (transcription.speakerId && data.speakerToDeleteId === transcription.speakerId) {
              transcription.speakerId = null;
            }
          });
          setMediaSpeakers(me.currentMedia);
        }
      });

      updatedSpeakerListener = $rootScope.$on('projectTranscripts.updatedSpeaker', function (event, data) {
        if (me.currentMedia && me.currentMedia.id === data.mediaId) {
          me.transcriptions.forEach(function (transcription) {
            if (transcription.speaker && data.updatedSpeaker.id === transcription.speaker.id) {
              angular.merge(transcription.speaker, data.updatedSpeaker);
            }
          });
        }
      });

      scrollElementContainer.addEventListener('scroll', onWindowScroll);
    }

    function unsubscribeFromEvents() {
      smartCommandsService.unbindAll(PROJECT_TRANSCRIBING_SHORTCUTS);

      addedTranscriptionListener();

      createdSpeakerListener();
      deletedSpeakerListener();
      updatedSpeakerListener();

      $window.onbeforeunload = false;

      scrollElementContainer.removeEventListener('scroll', onWindowScroll);
    }

    function onWindowScroll() {
      if (!isAutomaticScrollExecuting) {
        var scrollPos = domHelperService.getScrollPosition(me.scrollContainerSelector);
        if (lastReachedAutoScrollYPosition && scrollPos !== lastReachedAutoScrollYPosition) {
          if (domHelperService.isScrollAtTheBottom(me.scrollContainerSelector)) {
            return;
          }
          me.isAutoScrollActive = false;
        }
      }
    }

    function getFrameSeparatorString() {
      var frameSeparatorString = ';';

      if (me.currentMedia.fps % 1 === 0 || me.currentMedia.fps === 23.976) {
        frameSeparatorString = ':';
      }
      return frameSeparatorString;
    }

    function canExportProject() {
      return me.project.status === 'ready' || me.project.status === 'translated' || me.project.status === 'subtitled';
    }

    function canExportCurrentMedia() {
      return me.currentMedia && (me.currentMedia.status === 'transcribed' || me.currentMedia.status === 'translated' || me.currentMedia.status === 'subtitled');
    }

    function playPauseVideo($event) {
      if ($event && $event.type === 'keydown') {
        return;
      }
      me.API.playPause();
    }

    function addTimeVideo(valueInSeconds) {
      me.API.seekTime((me.API.currentTime / 1000) + valueInSeconds);
    }

    function bookmarkCurrentTranscription($event) {
      if (me.isPublicPageView) {
        return;
      }

      if ($event && $event.type === 'keydown') {
        return;
      }

      var currentTranscription = getCurrentTranscription();
      if (currentTranscription) {
        me.bookmark(currentTranscription);
      }
    }

    function isCurrentMediaTranslating() {
      return me.currentMedia && me.currentMedia.status === 'translating';
    }

    function isCurrentMediaTranscribing() {
      //TODO: Considering "ready" is only a fast fix for UI
      return me.currentMedia &&  (me.currentMedia.status === 'transcribing' ||  me.currentMedia.status === 'ready');
    }

    function getTimeInBar(percentage) {
      var mediaTimeCodeOffset = me.mediaTimecode.time;
      if (mediaTimeCodeOffset) {
        mediaTimeCodeOffset = $window.moment.duration(mediaTimeCodeOffset)._milliseconds;
      } else {
        mediaTimeCodeOffset = 0;
      }

      return $filter('milliToTime')(mediaTimeCodeOffset + (percentage * me.API.totalTime));
    }

    function getCurrentMediaIndex() {
      if (!me.currentMedia) {
        return;
      }
      return me.medias.findIndex(function (media) {
        return media.id === me.currentMedia.id;
      });
    }

    function goToPreviousTranscriptFile() {
      if (getCurrentMediaIndex() > 0) {
        var mediaIndex = getCurrentMediaIndex() - 1;
        onSelectMedia(me.medias[mediaIndex]);
      }
    }

    function goToNextTranscriptFile() {
      if (me.medias.length > 1 && getCurrentMediaIndex() < me.medias.length - 1) {
        var mediaIndex = getCurrentMediaIndex() + 1;
        onSelectMedia(me.medias[mediaIndex]);
      }
    }

    function initCountdownDecimalSeconds() {
      decimalSecondsInterval = $interval(function () {
        var countdownDecimalSecondsValue = parseInt(me.countdownDecimalSeconds, 10);
        --countdownDecimalSecondsValue;

        if (countdownDecimalSecondsValue <= 0) {
          me.countdownDecimalSeconds = '999';
        } else if (countdownDecimalSecondsValue < 100) {
          me.countdownDecimalSeconds = '0' + countdownDecimalSecondsValue;
        } else if (countdownDecimalSecondsValue < 10) {
          me.countdownDecimalSeconds = '00' + countdownDecimalSecondsValue;
        } else {
          me.countdownDecimalSeconds = String(countdownDecimalSecondsValue);
        }
      }, 1);
    }

    function onTimerStarted() {
      initCountdownDecimalSeconds();
    }

    function onTimerFinished() {
      $interval.cancel(decimalSecondsInterval);
      me.countdownDecimalSeconds = '000';
    }

    function onUpdateVideoTime(currentTimeInSeconds, durationInSeconds) {
      if (durationInSeconds && !isNaN(durationInSeconds) && !isNaN(currentTimeInSeconds)) {
        if (me.waveSurfer && me.waveSurfer.instance && me.waveSurfer.instance.getDuration()) {
          me.waveSurfer.instance.seekTo(currentTimeInSeconds / durationInSeconds);
        }
      }
    }

    function onPlayerReady(API) {
      me.API = API;
      me.trackState.volume = me.API.volume * 100;
      if (me.API.mediaElement) {
        $timeout(function () {
          me.API.mediaElement.attr('playsinline', '');
          me.API.mediaElement.attr('webkit-playsinline', '');
        });
      }
    }

    function onUpdateState(state) {
      me.trackState.isPlaying = state === 'play';
    }

    function onUpdateVolume(volume) {
      if (!isNaN(volume)) {
        me.trackState.volume = volume * 100;
      }
    }

    function handleMediasChange() {
      me.sources = [];

      me.medias.forEach(function (mediaItem) {
        var mediaSourceInfo = getMediaSourceInfo(mediaItem);
        me.sources.push(mediaSourceInfo);
      });
    }

    function getMediaSourceInfo(media) {
      var videoFilePath = '';
      var audioFilePath = '';
      var mediaSources = [];
      var sourceType = '';

      if (media.videoFilePath) {
        videoFilePath = $sce.trustAsResourceUrl(media.videoFilePath.replace('.mp4', ''));
        mediaSources = [
          {
            src: videoFilePath + '.mp4',
            type: 'video/mp4'
          },
          {
            src: videoFilePath + '.ogg',
            type: 'video/ogg'
          }
        ];
        sourceType = 'video';
      } else if (media.audioFileForWaveFormUrl) {
        audioFilePath = $sce.trustAsResourceUrl(media.audioFileForWaveFormUrl);
        mediaSources = [
          {
            src: audioFilePath,
            type: 'audio/' + fileHelperService.getFileExtension(media.audioFileForWaveFormUrl)
          }
        ];
        sourceType = 'audio';
      } else {
        sourceType = 'audio';
      }

      return {
        sourceType: sourceType,
        sources: mediaSources
      };
    }

    function updatePlayerInfo(updatedMediaInfo) {
      var mediaIndex = me.medias.findIndex(function (media) {
        return media.id === updatedMediaInfo.id;
      });

      var mediaSourceInfo = getMediaSourceInfo(updatedMediaInfo);

      me.sources[mediaIndex] = mediaSourceInfo;
      me.medias[mediaIndex].frameFilePath = updatedMediaInfo.frameFilePath;

      if (me.currentMedia.id === updatedMediaInfo.id) {
        angular.merge(me.currentMedia, updatedMediaInfo);

        updateMediaSources(mediaIndex);
      }
    }

    function onTranscriptionWordsChange(words, updatedTranscription, refresh) {
      var transcriptionToUpdateIndex = me.transcriptions.findIndex(function (transcription) {
        return transcription.id === updatedTranscription.id;
      });

      if (refresh) {
        updatedTranscription.words = words;
        var copyPreviousTranscription = angular.copy(updatedTranscription);
        copyPreviousTranscription.wordsJson = angular.toJson(words);

        // Force redraw ng repeat. Fix ngrepeats deleted due to contentEditable in the first letter
        me.transcriptions.splice(transcriptionToUpdateIndex, 1, copyPreviousTranscription);
      }

      updatedTranscription.wordsJson = angular.toJson(words);
      me.onTranscriptionChange({updatedTranscription: updatedTranscription, mediaId: me.currentMedia.id});
    }

    function onTranscriptionWordsCreate(words, previousTranscription) {
      var newTranscription = {
        startTime: words[0] ? words[0].startTime : '',
        endTime: words[0] ? words[0].endTime : '',
        wordsJson: angular.toJson(words),
        speaker: previousTranscription.speaker
      };

      var previousIndex = me.transcriptions.findIndex(function (transcriptionItem) {
        return transcriptionItem.id === previousTranscription.id;
      });

      var indexToInsertNewTranscription = _.isNil(previousIndex) ? null : (previousIndex + 1);

      me.onTranscriptionAdd({
        newTranscription: newTranscription,
        mediaId: me.currentMedia.id,
        indexToInsertNewTranscription: indexToInsertNewTranscription
      });
    }

    function onTranscriptionWordsRemove(words, previousWords, transcriptionToDelete) {
      var transcriptionToDeleteId = transcriptionToDelete.id;
      var transcriptionToDeleteIndex = me.transcriptions.findIndex(function (transcription) {
        return transcription.id === transcriptionToDeleteId;
      });

      if (transcriptionToDeleteIndex > 0) {
        var previousTranscription = me.transcriptions[transcriptionToDeleteIndex - 1];

        var copyPreviousTranscription = angular.copy(previousTranscription);

        var oldLastWordElementIndex = copyPreviousTranscription.words.length - 1;
        copyPreviousTranscription.endTime = transcriptionToDelete.endTime;
        copyPreviousTranscription.words = previousWords.concat(words);

        // Force redraw ng repeat. Fix ngrepeats deleted due to contentEditable in the firs letter
        me.transcriptions.splice(transcriptionToDeleteIndex, 1);
        me.transcriptions.splice(transcriptionToDeleteIndex - 1, 1, copyPreviousTranscription);

        me.onTranscriptionDelete({transcriptionToDeleteId: transcriptionToDeleteId, mediaId: me.currentMedia.id});

        $timeout(function () {
          $rootScope.$broadcast('transcriptionRow.autoFocus', {
            transcription: copyPreviousTranscription,
            caretPosition: oldLastWordElementIndex,
            atStart: false
          });
        });

        onTranscriptionWordsChange(copyPreviousTranscription.words, copyPreviousTranscription, true);
      }
    }

    function changePlaySpeed(autoRotate, isAntiClockWiseDirection, $event) {
      if ($event && $event.type === 'keydown') {
        return;
      }
      var rateIndex = 0;
      var currentRateIndex = me.config.playbackSpeeds.indexOf(String(me.API.playback));
      var offsetIndex = isAntiClockWiseDirection ? -1 : 1;

      if (currentRateIndex !== -1) {
        rateIndex = currentRateIndex + offsetIndex;

        if (!me.config.playbackSpeeds[rateIndex] && autoRotate) {
          if (currentRateIndex === 0) {
            rateIndex = me.config.playbackSpeeds.length - 1;
          } else if (currentRateIndex === me.config.playbackSpeeds.length - 1) {
            rateIndex = 0;
          }
        }
      }

      var newRateValue = me.config.playbackSpeeds[rateIndex];

      me.API.setPlayback(newRateValue);

      me.trackState.playSpeed = newRateValue;
    }

    function onStartAutoScroll() {
      isAutomaticScrollExecuting = true;
    }

    function onFinishAutoScroll(yPosition) {
      lastReachedAutoScrollYPosition = yPosition;
      isAutomaticScrollExecuting = false;
    }

    function toggleVolumeState($event) {
      if ($event && $event.type === 'keydown') {
        return;
      }

      if (me.API.volume >= 0 && me.API.volume < 0.33) {
        me.API.setVolume(0.33);
      } else if (me.API.volume >= 0.33 && me.API.volume < 0.66) {
        me.API.setVolume(0.66);
      } else if (me.API.volume >= 0.66 && me.API.volume < 1) {
        me.API.setVolume(1);
      } else if (me.API.volume >= 1) {
        me.API.setVolume(0);
      }
    }

    me.updateCuePoints = function () {
      var bookmarkedTranscriptions = me.config.plugins.cuepoints.points = me.transcriptions.filter(function (transcription) {
        return Boolean(transcription.bookmark);
      });

      me.config.plugins.cuepoints.points = bookmarkedTranscriptions.map(function (bookmarkTranscription) {
        return {time: parseFloat(bookmarkTranscription.startTime)};
      });

      me.waveFormBookmarksInSeconds = bookmarkedTranscriptions.map(function (bookmarkTranscription) {
        return {
          start: parseFloat(bookmarkTranscription.startTime),
          end: parseFloat(bookmarkTranscription.endTime)
        };
      });
    };

    function onSelectMedia(media) {
      if(angular.isFunction(me.onMediaSelect)) {
        me.onMediaSelect({selectedMedia: media});
      }
      setVideo(media);
    }

    function setVideo(media) {
      if (!me.API) {
        return;
      }
      me.API.stop();
      lastReachedAutoScrollYPosition = null;
      me.showVideo = true;
      showMediaTranscriptions(media);
      setMediaSpeakers(media);
      updatePlayerInfo(media);
      var delayToWaitRenderingRows = 500;
      $timeout(function () {
        zenscroll.toY(0, 0);
      }, delayToWaitRenderingRows);
    }

    function updateMediaSources(mediaIndex) {
      $timeout(function () {
        if (me.sources[mediaIndex]) {
          me.config.sources = me.sources[mediaIndex].sources;
          me.config.sourceType = me.sources[mediaIndex].sourceType;
        }
        if (me.medias[mediaIndex]) {
          me.config.plugins.poster = me.medias[mediaIndex].frameFilePath;
        }

        me.waveSurfer.audioUrl = me.medias[mediaIndex].audioFileForWaveFormUrl;

        if (me.medias[mediaIndex].peaks) {
          me.waveSurfer.peaks = angular.fromJson(me.medias[mediaIndex].peaks);
        }

        if (!me.waveSurfer.instance) {
          return;
        }

        me.waveSurfer.instance.on('seek', function (waveProgress) {
          var videogularProgress = me.API.currentTime / me.API.totalTime;
          var deltaSyncToCompare = 0.000001;

          if (Math.abs(videogularProgress - waveProgress) > deltaSyncToCompare) {
            var moveToPercent = waveProgress * 100;
            me.API.seekTime(moveToPercent, true);
          }

        });
      });
    }

    function addTranscription(transcription, autoFocus, arrayPosition) {
      var transcriptionToUpdate = me.transcriptions.find(function (transcriptionItem) {
        return transcriptionItem.id === transcription.id;
      });
      addUIPropertiesToTranscription(transcription);

      if (transcriptionToUpdate) {
        angular.merge(transcriptionToUpdate, transcription);
      } else if (transcription.startTime) {
        if (_.isNil(arrayPosition)) {
          me.transcriptions.push(transcription);

          me.transcriptions.sort(function (a, b) {
            if (parseFloat(a.startTime) > parseFloat(b.startTime)) {
              return 1;
            }
            if (parseFloat(b.startTime) > parseFloat(a.startTime)) {
              return -1;
            }

            if (a.id > b.id) {
              return 1;
            }
            if (b.id > a.id) {
              return -1;
            }

            return 0;
          });
        } else {
          me.transcriptions.splice(arrayPosition, 0, transcription);
        }

        if (autoFocus) {
          $timeout(function () {
            $rootScope.$broadcast('transcriptionRow.autoFocus', {
              transcription: transcription,
              caretPosition: 0,
              atStart: true
            });
          });
        }
      }
    }

    function addUIPropertiesToTranscription(transcription) {
      transcription.words = [];
      if (transcription.wordsJson) {
        try {
          transcription.words = angular.fromJson(transcription.wordsJson);
          transcription.readOnlyText = transcription.words.map(function (word) {
            return word ? word.text : '';
          }).join('');
        } catch (e) {
          console.log(e);
        }
      }

      if (angular.isArray(transcription.words) &&
          transcription.words.length &&
          transcription.words[0] &&
          transcription.words[transcription.words.length - 1]
      ) {
        transcription.startTime = transcription.words[0].startTime;
        transcription.endTime = transcription.words[transcription.words.length - 1].endTime;
      }

      return transcription;
    }

    function setMediaSpeakers(media) {
      if (!media || !angular.isArray(media.speakers)) {
        return;
      }

      media.speakers.sort(function (s1, s2) {
        return s1.name < s2.name ? -1 : s1.name > s2.name ? 1 : 0;
      });

      me.speakers = media.speakers;
    }

    function showMediaTranscriptions(media) {
      if (media) {
        me.trackState.type = me.currentMedia.type;
        me.showVideo = true;
        me.trackState.isVideoHidden = !me.showVideo;

        me.trackState.isPlaying = false;
        me.trackState.playSpeed = '1';

        if (media.userDefinedTimeCode || media.userDefinedTimeCodeFrames) {
          if (media.userDefinedTimeCode) {
            var momObj = moment.duration(media.userDefinedTimeCode);

            var hours = momObj._data.hours;
            if (momObj._data.days) {
              hours += 24 * momObj._data.days;
            }

            me.mediaTimecode.time = hours + ':' + momObj._data.minutes + ':' + momObj._data.seconds;
          }

          if (media.userDefinedTimeCodeFrames) {
            me.mediaTimecode.frames = String(media.userDefinedTimeCodeFrames);
          }
        } else if (media.timeCode) {
          me.mediaTimecode.time = media.timeCode.substring(0, 8);
          me.mediaTimecode.frames = media.timeCode.substring(9, 11);
        } else {
          me.mediaTimecode.time = null;
          me.mediaTimecode.frames = null;
        }

        if (!me.currentMedia.fps) {
          me.currentMedia.fps = 29.97;
        }

        if (!me.mediaTimecode.frames) {
          me.mediaTimecode.frames = '00';
        }

        me.currentMediaName = media.name;
        me.currentMediaId = media.id;
      }

    }

    function isPlaying(stringStartTimeInSeconds, stringEndTimeInSeconds, isWord) {
      if (!me.API) {
        return;
      }
      var currentTimeInMilliSeconds = Math.round(me.API.currentTime);
      var millisecondsStart = parseFloat(stringStartTimeInSeconds) * 1000;
      var millisecondsEnd = parseFloat(stringEndTimeInSeconds) * 1000;
      return currentTimeInMilliSeconds >= millisecondsStart && (isWord || currentTimeInMilliSeconds < millisecondsEnd);
    }

    function playTime(stringTimeInSeconds, $event) {

      if ($event && $event.type === 'keydown') {
        return;
      }

      var milliseconds = parseFloat(stringTimeInSeconds) * 1000;

      var moveToPercent = milliseconds / me.API.totalTime;

      me.API.seekTime(moveToPercent * 100, true);


      if (me.API.currentState === 'pause' || me.API.currentState === 'stop') {
        me.API.play();
        $timeout(function () {
          me.API.pause();
        }, 100);
      }
    }

    function playWordTime(event) {
      if (event.type !== 'click') {
        return;
      }
      if (event.ctrlKey || event.metaKey) {
        var stringTimeInSeconds = $(event.target).attr('data-startTime');
        playTime(stringTimeInSeconds);
      }
    }

    me.isCurrentVideoMediaTranscoding = function () {
      if (!me.currentMedia) {
        return false;
      }
      return me.currentMedia.type === 'video' && me.currentMedia.type !== me.config.sourceType;
    };

    me.forceLock = function() {
      forceLock();
    }

    me.saveMedia = function (media) {
      me.popoverTimecode.isOpen = false;
      me.popoverTimecodeForMobile.isOpen = false;

      if (me.mediaTimecode.time) {
        var time = me.mediaTimecode.time;

        media.userDefinedTimeCode = moment.duration(time)._milliseconds;
        media.userDefinedTimeCodeFrames = parseInt(me.mediaTimecode.frames, 10);
      }

      me.onMediaChange({updatedMedia: media});

      if (me.applyFrameRateToAllProject && angular.isFunction(me.onProjectFpsChange)) {
        me.onProjectFpsChange({
          projectId: me.project.id,
          fps: media.fps
        });
        me.applyFrameRateToAllProject = false;
      }
    };

    me.saveAnnotation = function (transcription) {
      me.openPopoverAnnotations[transcription.id] = false;
      me.onTranscriptionChange({updatedTranscription: transcription, mediaId: me.currentMedia.id});
    };

    me.cancelAnnotation = function (transcription) {
      me.openPopoverAnnotations[transcription.id] = false;
    };

    me.cancelTimecode = function () {
      me.popoverTimecode.isOpen = false;
      me.popoverTimecodeForMobile.isOpen = false;
    };

    me.openSearchInput = function () {
      me.searchInput.isOpen = false;
      $timeout(function () {
        me.searchInput.isOpen = true;
      }, 300);
    };

    me.bookmark = function (transcription) {
      transcription.bookmark = !transcription.bookmark;
      me.onTranscriptionChange({updatedTranscription: transcription, mediaId: me.currentMedia.id});
      me.updateCuePoints();
    };

    me.toggleBookmarkOnly = function ($event) {
      if ($event && $event.type === 'keydown') {
        return;
      }
      me.showOnlyBookmarks = !me.showOnlyBookmarks;
    };

    me.toggleNotesFilter = function ($event) {
      if ($event && $event.type === 'keydown') {
        return;
      }
      me.showOnlyAnnotations = !me.showOnlyAnnotations;
    };

    me.toggleVideoVisibility = function ($event) {
      if ($event && $event.type === 'keydown') {
        return;
      }

      me.showVideo = !me.showVideo;
      me.trackState.isVideoHidden = !me.showVideo;
    };

    me.turnOnAutoScroll = function () {
      me.isAutoScrollActive = true;
    };

    function getCurrentTranscription() {
      return me.transcriptions.find(function (transcription) {
        return isPlaying(transcription.startTime, transcription.endTime);
      });
    }

    function goToPreviousTranscription(onlyWithBookmark, $event) {
      if ($event && $event.type === 'keydown') {
        return;
      }

      var currentTimeInMilliSeconds = me.API.currentTime;

      // Array should be ordered otherwise won't work
      var previousAndCurrentTranscriptions = me.transcriptions.filter(function (transcription) {
        return ((parseFloat(transcription.startTime) * 1000) <= currentTimeInMilliSeconds) && (transcription.bookmark || !onlyWithBookmark);
      });

      var previousTranscription;

      if (previousAndCurrentTranscriptions.length > 1) {
        previousTranscription = previousAndCurrentTranscriptions[previousAndCurrentTranscriptions.length - 2];
      } else if (previousAndCurrentTranscriptions.length > 0) {
        previousTranscription = previousAndCurrentTranscriptions[0];
      }

      if (previousTranscription) {
        $timeout(function () {
          playTime(previousTranscription.startTime);
        });
      }
    }

    function goToNextTranscription(onlyWithBookmark, $event) {
      if ($event && $event.type === 'keydown') {
        return;
      }

      var currentTimeInMilliSeconds = me.API.currentTime;

      var nextTranscription = me.transcriptions.find(function (transcription) {
        return ((parseFloat(transcription.startTime) * 1000) > currentTimeInMilliSeconds) && (transcription.bookmark || !onlyWithBookmark);
      });

      if (nextTranscription) {
        $timeout(function () {
          playTime(nextTranscription.startTime);
        });
      }
    }

    function getNoRepeatedColor() {
      var availableColors = _.differenceBy(SPEAKER_COLORS, me.currentMedia.speakers, 'color');
      if (availableColors[0]) {
        return availableColors[0].color;
      }
    }

    function getFormattedTimestamp(timeInSeconds) {
      var startTimecodeOffset = me.mediaTimecode.time;
      var startTimecodeInSeconds = $window.moment.duration(startTimecodeOffset)._milliseconds / 1000;

      return $filter('secondsToTime')(startTimecodeInSeconds + parseFloat(timeInSeconds));
    }

    me.getProjectTotalTime = function () {
      var accumulatedMedia = me.medias.reduce(function (a, b) {
        return {duration: a.duration + b.duration};
      });

      return $filter('secondsToTime')(accumulatedMedia.duration);
    };

    me.getProjectBookmarkedTime = function () {
      var totalTime = 0;
      var bookmarkedTranscriptions = me.transcriptions.filter(function (transcription) {
        return Boolean(transcription.bookmark);
      });

      for (var iTranscription in bookmarkedTranscriptions) {
        var transcription = bookmarkedTranscriptions[iTranscription];
        var init = $filter('timeToSeconds')(transcription.start);
        var end = $filter('timeToSeconds')(transcription.finish);

        totalTime += (end - init);
      }

      return $filter('secondsToTime')(totalTime);
    };

    me.videoTime = function (time) {
      var mediaCode = me.mediaTimecode.time;
      if (mediaCode) {
        return moment.duration(time + moment.duration(mediaCode)._milliseconds);
      } else {
        return moment.duration(time);
      }
    };

    me.annotationPopover = {
      isOpen: false,
      templateUrl: 'annotationPopoverTemplate.html',

      open: function () {
        me.annotationPopover.isOpen = true;
        me.annotationPopover.data = {};
      },

      close: function () {
        me.annotationPopover.isOpen = false;
      }
    };

    me.updateProject = function () {
      var updatedFields = {
        id: me.project.id,
        name: me.project.name
      };
      me.onProjectChange({updatedProject: updatedFields});
    };

    me.blurOnEnter = function ($event) {
      if ($event.keyCode === 13) {
        $event.target.blur();
      }
    };

    me.toggleCheatSheet = function () {
      smartCommandsService.toggleCheatSheet();
    };

    function addSpeaker(transcription) {
      if (!me.newSpeaker.name) {
        return;
      }

      me.newSpeaker.name = me.newSpeaker.name.trim();

      if (!me.newSpeaker.name) {
        return;
      }

      me.newSpeaker.color = getNoRepeatedColor();

      me.onSpeakerAdd({newSpeaker: me.newSpeaker, mediaId: me.currentMedia.id, transcription: transcription});
    }

    me.speakerOnKeyPress = function ($event, transcription) {
      if ($event.keyCode === 13) {
        addSpeaker(transcription);
      }
    };

    me.addSpeakerOnBlur = function ($event, transcription) {
      addSpeaker(transcription);
    };

    me.unSelectSpeakerFromRow = function (transcription) {
      transcription.speaker = null;
      me.onTranscriptionChange({updatedTranscription: transcription, mediaId: me.currentMedia.id});
    };

    function updateMediaSpeaker(speaker) {
      var copiedSpeaker = angular.copy(speaker);
      if (copiedSpeaker.name) {
        me.onSpeakerUpdate({speakerToUpdate: copiedSpeaker, mediaId: me.currentMedia.id});
      } else {
        me.onSpeakerDelete({speakerToDelete: copiedSpeaker, mediaId: me.currentMedia.id});
      }
    }

    function getNoSpeakerSymbol() {
      return me.languageTextDirection === 'rtl' ? '<' : '>';
    }

    function canMergeTracks() {
      return me.user && me.user.ableToSync === true;
    }

    me.onEnterWhileUpdating = function ($event, transcription) {
      if ($event.keyCode === 13) {
        transcription.isSpeakerMenuOpen = false;
      }
    };

    me.setTranscriptionSpeaker = function (transcription, speaker) {
      if (!transcription) {
        return;
      }
      transcription.speaker = speaker;
      transcription.speakerId = speaker.id;
      me.onTranscriptionChange({updatedTranscription: transcription, mediaId: me.currentMedia.id});
      transcription.isSpeakerMenuOpen = false;
    };

    me.getSpeakerCssStyle = function (speaker) {
      var colorObject = SPEAKER_COLORS.find(function (speakerColorItem) {
        if (speaker) {
          return speakerColorItem.color === speaker.color;
        }
        return false;
      });
      if (colorObject) {
        return {
          'background-color': colorObject.color,
          color: colorObject.label
        };
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('ai.simonCommonUi')
    .component('plainLogo', {
      controller: PlainLogoController,
      bindings: {
        logoHref: '@'
      },
      templateUrl: 'components/plain-logo/plain-logo.component.html'
    });

  PlainLogoController.$inject = ['domHelperService'];

  function PlainLogoController(domHelperService) {
    var me = this;
    me.inIframe = domHelperService.inIframe;
  }
})();

(function () {
  'use strict';

  angular
    .module('ai.simonCommonUi')
    .component('animatedLogo', {
      controller: AnimatedLogoController,
      bindings: {
        logoHref: '@'
      },
      templateUrl: 'components/animated-logo/animated-logo.component.html'
    });

  AnimatedLogoController.$inject = ['domHelperService'];

  function AnimatedLogoController(domHelperService) {
    var me = this;
    me.inIframe = domHelperService.inIframe;
  }
})();

(function () {
  'use strict';

  angular
    .module('ai.simonCommonUi')
    .component('miniPlayer', {
      controller: MiniPlayerController,
      bindings: {
        isPublicPageView: '=',
        onClickPlayPause: '&',
        onChangeVolume: '&',
        onClickVolume: '&',
        onClickVideo: '&',
        onClickPreviousBookmark: '&',
        onClickNextBookmark: '&',
        onClickChangePlaySpeed: '&',
        onClickBookmark: '&',
        trackState: '<'

      },
      templateUrl: 'components/mini-player/mini-player.component.html'
    });

  MiniPlayerController.$inject = [];

  function MiniPlayerController() {
    var me = this;

    me.$onInit = onInit;
    me.isMuted = isMuted;
    me.isVideo = isVideo;
    me.isVideoHidden = isVideoHidden;
    me.getVolumeCirclePercentage = getVolumeCirclePercentage;

    function onInit() {
    }

    function isMuted() {
      return me.trackState.volume === 0;
    }

    function getVolumeCirclePercentage() {
      if (me.trackState.volume >= 0 && me.trackState.volume < 33) {
        return 0;
      } else if (me.trackState.volume >= 33 && me.trackState.volume < 66) {
        return 33;
      } else if (me.trackState.volume >= 66 && me.trackState.volume < 100) {
        return 66;
      } else if (me.trackState.volume >= 100) {
        return 100;
      }
    }

    function isVideo() {
      return me.trackState.type === 'video';
    }

    function isVideoHidden() {
      return me.trackState.isVideoHidden;
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('ai.simonCommonUi')
    .factory('stringHelperService', stringHelperService);

  stringHelperService.$inject = [];

  function stringHelperService() {
    var defaultChars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';

    return {
      replaceAll: replaceAll,
      generateRandomString: generateRandomString,
      removeAllSpecialChars: removeAllSpecialChars,
      removeExtraWhiteSpaces: removeExtraWhiteSpaces,
      convertHtmlToText: convertHtmlToText
    };

    function generateRandomString(length, chars) {
      chars = chars || defaultChars;
      var result = '';
      for (var i = length; i > 0; --i) {
        result += chars[Math.round(Math.random() * (chars.length - 1))];
      }
      return result;
    }

    function replaceAll(target, search, replacement) {
      return target.replace(new RegExp(search, 'g'), replacement);
    }

    function removeAllSpecialChars(stringToReplace, allowWhiteSpace) {
      var regex = allowWhiteSpace ? /[^\w\s]/gi : /[^\w]/gi;
      return stringToReplace.replace(regex, '');
    }

    function removeExtraWhiteSpaces(stringToReplace) {
      return stringToReplace.replace(/\s\s+/g, ' ');
    }

    function convertHtmlToText(value) {
      // Convert `&amp;` to `&`.
      value = value.replace(/&amp;/gi, '&');

      // Replace spaces.
      value = value.replace(/&nbsp;/gi, ' ');
      // value = value.replace(/\s+/g, ' ');

      // Remove "<b>".
      value = value.replace(/<b>/gi, '');
      value = value.replace(/<\/b>/gi, '');

      // Remove "<strong>".
      value = value.replace(/<strong>/gi, '');
      value = value.replace(/<\/strong>/gi, '');

      // Remove "<i>".
      value = value.replace(/<i>/gi, '');
      value = value.replace(/<\/i>/gi, '');

      // Remove "<em>".
      value = value.replace(/<em>/gi, '');
      value = value.replace(/<\/em>/gi, '');

      // Remove "<u>".
      value = value.replace(/<u>/gi, '');
      value = value.replace(/<\/u>/gi, '');

      // Tighten up "<" and ">".
      value = value.replace(/>\s+/g, '>');
      value = value.replace(/\s+</g, '<');

      // Replace "<br>".
      value = value.replace(/<br>/gi, '\n');

      // Replace "<div>" (from Chrome).
      value = value.replace(/<div>/gi, '\n');
      value = value.replace(/<\/div>/gi, '');

      // Replace "<p>" (from IE).
      value = value.replace(/<p>/gi, '\n');
      value = value.replace(/<\/p>/gi, '');

      // Whitespace before/after. Preserving new lines
      // value = value.replace(/^ +| +$/gm, "");

      return value;
    }
  }

})();


(function () {
  'use strict';

  angular
    .module('ai.simonCommonUi')
    .factory('smartCommandsService', smartCommandsService);

  smartCommandsService.$inject = ['$timeout', '$window', 'hotkeys', 'stringHelperService'];

  function smartCommandsService($timeout, $window, hotkeys, stringHelperService) {
    var hotkeysContainerElement = $window.document.getElementsByClassName('cfp-hotkeys');
    var preventDefaultTabBrowser = false;
    var classesToPreventTabFrom = [];

    angular.element(hotkeysContainerElement).bind('click', function (event) {
      $timeout(function () {
        if (event.target === hotkeysContainerElement[0]) {
          hotkeys.toggleCheatSheet();
        }
      });
    });

    return {
      bind: bind,
      toggleCheatSheet: toggleCheatSheet,
      setCheatSheetShortcut: setCheatSheetShortcut,
      deleteDefaultCheatSheetShortcut: deleteDefaultCheatSheetShortcut,
      pause: pause,
      unpause: unpause,
      unbind: unbind,
      unbindAll: unbindAll,
      preventSpaceKeyBoard: preventSpaceKeyBoard
    };

    function preventSpaceKeyBoard(preventDefaultBrowser, classesToPrevent) {
      preventDefaultTabBrowser = preventDefaultBrowser;
      classesToPreventTabFrom = classesToPrevent;
      $window.addEventListener('keydown', preventSpaceKeyBoardListener);
    }

    function preventSpaceKeyBoardListener(e) {
      if (e.keyCode === 32) {
        if (preventDefaultTabBrowser && e.target === $window.document.body) {
          e.preventDefault();
          return;
        }

        if (angular.isArray(classesToPreventTabFrom)) {
          classesToPreventTabFrom.forEach(function (className) {
            if ($(e.target).hasClass(className)) {
              e.preventDefault();
            }
          });
        }
      }
    }

    // It is recommended dont pass a callback that has parameters due to in run time 'hotkeys' add its own.
    function bind(shortcutConfiguration, callback) {
      var hotkeyObject = angular.copy(shortcutConfiguration);
      hotkeyObject.callback = callback;
      hotkeys.add(hotkeyObject);
    }

    function unbind(shortcutConfiguration) {
      hotkeys.del(shortcutConfiguration.combo);
    }

    function unbindAll(shortcutMap) {
      angular.forEach(shortcutMap, function (shortcut) {
        hotkeys.del(shortcut.combo);
      });

      $window.removeEventListener('keydown', preventSpaceKeyBoardListener);
    }

    function pause() {
      hotkeys.pause();
    }

    function unpause() {
      hotkeys.unpause();
    }

    function deleteDefaultCheatSheetShortcut() {
      hotkeys.del('?');
    }

    function toggleCheatSheet() {
      $timeout(function () {
        hotkeys.toggleCheatSheet();
        $(hotkeysContainerElement).find('.cfp-hotkeys-key').each(function (index, hotKeyElement) {
          var combo = $(hotKeyElement).html();
          if (combo.includes('\u21E7')) {
            $(hotKeyElement).html(replaceShiftSymbol(combo));
          }
        });
      });
    }

    function replaceShiftSymbol(combo) {
      return stringHelperService.replaceAll(combo, '\u21E7', 'shift');
    }

    function setCheatSheetShortcut(shortcutConfiguration) {
      hotkeys.del('?');
      var hotkeyObject = angular.copy(shortcutConfiguration);
      hotkeyObject.callback = function (event) {
        if (event.preventDefault) {
          event.preventDefault();
        } else {
          // Internet explorer
          event.returnValue = false;
        }
        hotkeys.toggleCheatSheet();
      };
      hotkeys.add(hotkeyObject);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('ai.simonCommonUi')
    .factory('fileHelperService', fileHelperService);

  fileHelperService.$inject = [];

  function fileHelperService() {
    return {
      getFileExtension: getFileExtension
    };

    function getFileExtension(filename) {
      var parts = filename.split('.');
      if (parts.length > 1 && parts[0]) {
        return parts[parts.length - 1].toLowerCase();
      }
      return '';
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('ai.simonCommonUi')
    .factory('domHelperService', domHelperService);

  domHelperService.$inject = ['$window'];

  function domHelperService($window) {
    return {
      getScrollPosition: getScrollPosition,
      isScrollAtTheBottom: isScrollAtTheBottom,
      isScrollAlmostAtBottom: isScrollAlmostAtBottom,
      inIframe: inIframe
    };

    function getElementFromSelector(selector) {
      return selector ? angular.element(selector)[0] : $window;
    }

    function getScrollPosition(selector) {
      var element = getElementFromSelector(selector);
      return element.scrollY || element.scrollTop || $window.document.getElementsByTagName('html')[0].scrollTop;
    }

    function isScrollAtTheBottom(selector) {
      var element = getElementFromSelector(selector);
      return element.innerHeight + getScrollPosition(selector) >= (selector ? element.scrollHeight : $window.document.body.scrollHeight);
    }

    function isScrollAlmostAtBottom(offset, selector) {
      var element = getElementFromSelector(selector);
      return element.innerHeight + getScrollPosition(selector) + offset >= (selector ? element.scrollHeight : $window.document.body.scrollHeight);
    }

    function inIframe() {
      try {
        return $window.self !== $window.top;
      } catch (e) {
        return true;
      }
    }
  }

})();


/**
 * Created by Luiz on 20/02/2017.
 */

(function () {
    'use strict';

    angular
        .module('ai.simonCommonUi')
        .filter('timeToSeconds', timeToSecondsFilter);

    function timeToSecondsFilter() {

        return function (time) {
            //i.e. 00:00:00
            var totalSeconds = 0;
            var commaIndex = time.indexOf(',');
            var decimals = 0;
            if (commaIndex >= 0) {
                // decimals = parseFloat("0."+time.substring(commaIndex+1));
                time = time.substring(0, commaIndex);
            }

            var timeArr = time.split(':');

            for (var i = 0; i < timeArr.length; i++) {
                var currentTime = parseInt(timeArr[i]);

                var counter = timeArr.length - i - 1;
                while (counter > 0) {
                    currentTime *= 60;
                    counter--;
                }

                totalSeconds += currentTime;
            }

            return totalSeconds;
        };
    }
})();



/**
 * Created by Luiz on 20/02/2017.
 */

(function () {
    'use strict';
    angular
        .module('ai.simonCommonUi')
        .filter('timeToMilli', timeToMilliFilter);

    function timeToMilliFilter() {

        return function (time) {
            //i.e. 00:00:00
            var totalMilli = 0;
            var commaIndex = time.indexOf(',');
            var decimals = 0;
            if (commaIndex >= 0) {
                decimals = parseInt(time.substring(commaIndex + 1));
                time = time.substring(0, commaIndex);
            }

            var timeArr = time.split(':');

            for (var i = 0; i < timeArr.length; i++) {
                var currentTime = parseInt(timeArr[i]);

                var counter = timeArr.length - i - 1;
                while (counter > 0) {
                    currentTime *= 60;
                    counter--;
                }

                totalMilli += currentTime;
            }

            return (totalMilli * 1000) + decimals;
        };
    }
})();


/**
 * Created by Luiz on 17/02/2017.
 */

(function () {
    'use strict';
    angular
        .module('ai.simonCommonUi')
        .filter('secondsToTime', secondsToTimeFilter);

    function secondsToTimeFilter() {

        function padTime(t) {
            return t < 10 ? '0'+t : t;
        }

        return function(_seconds) {
            if (typeof _seconds !== 'number' || _seconds < 0)
                return '00:00:00';

            var hours = Math.floor(_seconds / 3600),
                minutes = Math.floor((_seconds % 3600) / 60),
                seconds = Math.floor(_seconds % 60);

            if (hours > 0)
                return hours + ':' + padTime(minutes) + ':' + padTime(seconds);
            else
                return padTime(minutes) + ':' + padTime(seconds);
        };
    }
})();

/**
 * Created by Luiz on 17/02/2017.
 */

(function () {
    'use strict';
    angular
        .module('ai.simonCommonUi')
        .filter('milliToTime', milliToTimeFilter);

    function milliToTimeFilter() {

        function padTime(t) {
            return t < 10 ? '0' + t : t;
        }

        return function (_milliseconds, addMilliseconds, showHours) {
            var _seconds = _milliseconds / 1000;

            var millisecondsString = '';
            if (addMilliseconds) {
                millisecondsString = Math.floor(_milliseconds % 1000);
                millisecondsString = ',' + padTime(millisecondsString);
            }

            if (typeof _seconds !== 'number' || _seconds < 0)
                return '00:00:00';

            var hours = Math.floor(_seconds / 3600),
                minutes = Math.floor((_seconds % 3600) / 60),
                seconds = Math.floor(_seconds % 60);

            if (showHours || hours > 0)
                return padTime(hours) + ':' + padTime(minutes) + ':' + padTime(seconds) + millisecondsString;
            else
                return padTime(minutes) + ':' + padTime(seconds) + millisecondsString;
        };
    }

})();

(function () {
  'use strict';

  angular
    .module('ai.simonCommonUi')
    .filter('middleEllipses', middleEllipses);

  function middleEllipses() {

    var DEFAULT_MIDDLE_ELLIPSES_CHARACTER = '...';

    return function (input, limit, middleEllipsesCharacter) {

      middleEllipsesCharacter = middleEllipsesCharacter || DEFAULT_MIDDLE_ELLIPSES_CHARACTER;

      if (limit < 3) {
        throw new Error('middleEllipses: Limit should be at least 3');
      }

      // Do nothing, the string doesn't need truncation.
      if (input.length <= limit) {
        return input;
      }

      var lengthOfTheSidesAfterTruncation = Math.floor((limit - 1) / 2);
      var finalLeftPart = input.slice(0, lengthOfTheSidesAfterTruncation);
      var finalRightPart = input.slice(input.length - lengthOfTheSidesAfterTruncation);

      return finalLeftPart + middleEllipsesCharacter + finalRightPart;
    };

  }
})();

(function () {
    'use strict';

    angular
        .module('ai.simonCommonUi')
        .filter('initials', initials);

    initials.$inject = [];

    function initials() {
        return initialsFilter;

        function initialsFilter(fullName) {
            var result = '';

            if (fullName) {
                var value = fullName.trim();
                var parts = value.split(' ');
                if (parts.length > 1) {

                    result = parts.map(function (part) {
                        var possibleNumber = parseInt(part, 10);
                        if (isNaN(possibleNumber)) {
                            return part[0];
                        }
                        return possibleNumber;
                    }).join('').toUpperCase();

                    result = result.substring(0, 3);
                } else if (parts.length === 1) {
                    result = value.substring(0, 1).toUpperCase() + value.substring(1, 3);
                }
            }
            return result;
        }
    }

})();

(function () {
  'use strict';

  angular
    .module('ai.simonCommonUi')
    .directive('useSticky', useSticky);

  useSticky.$inject = ['$timeout', '$parse', '$window'];

  /* @ngInject */
  function useSticky($timeout, $parse, $window) {
    return {
      link: link,
      restrict: 'A'
    };

    function link(scope, element, attrs) {
      $window.addEventListener('scroll', runOnScroll);

      var elementOffsetTop = element[0].offsetTop;

      function runOnScroll() {
        $timeout(function () {
          var isStickyActiveModel = $parse(attrs.isStickyActive);

          if ($window.pageYOffset - 5 > elementOffsetTop) {
            element[0].classList.add('sticky');
            isStickyActiveModel.assign(scope, true);
          } else {
            element[0].classList.remove('sticky');
            isStickyActiveModel.assign(scope, false);
          }
        });
      }
    }
  }

})();


(function () {
  'use strict';
  angular
    .module('ai.simonCommonUi')
    .directive('transcriptionRow', transcriptionRowDirective);

  transcriptionRowDirective.$inject = ['$timeout', 'stringHelperService'];

  function transcriptionRowDirective($timeout, stringHelperService) {
    return {
      restrict: 'A',
      scope: {},
      bindToController: {
        transcriptionObject: '<transcriptionRow',
        isTranscriptionRowDisabled: '<transcriptionRowDisabled',
        onTranscriptionWordsChange: '&',
        onTranscriptionWordsCreate: '&',
        onTranscriptionWordsRemove: '&'
      },
      controller: TranscriptionRowController,
      controllerAs: '$ctrl',
      link: function (scope, element, attr, ctrl) {

        var down = false;
        var updateTimeout;
        var updateDelayInMilliseconds = 5000;

        var autoFocusListener;

        subscribeToEvents();

        function subscribeToEvents() {
          element.bind('input', onEditableContentChange);
          element.bind('paste', onPaste);
          $(element).on('keydown', onKeyDown);
          $(element).on('keyup', onKeyUp);

          autoFocusListener = scope.$on('transcriptionRow.autoFocus', function (event, data) {
            if (ctrl.isTranscriptionRowDisabled) {
              return;
            }
            if (data.transcription.id === ctrl.transcriptionObject.id) {
              $timeout(function () {
                setCaretPosition(element[0], data.caretPosition, data.atStart);
              });
            }
          });

          scope.$on('$destroy', function () {
            unsubscribeFromEvents();
          });
        }


        function unsubscribeFromEvents() {
          element.off('input', onEditableContentChange);
          element.off('paste', onPaste);
          $(element).off('keydown', onKeyDown);
          $(element).off('keyup', onKeyUp);

          if (angular.isFunction(autoFocusListener)) {
            autoFocusListener();
          }
        }

        function getTimecodedWords(text, startTimeString, endTimeString) {
          if (!text || !text.trim()) {
            return;
          }

          var startTime = parseFloat(startTimeString);
          var endTime = parseFloat(endTimeString);

          var textArray = text.split(' ').filter(function (word) {
            return !!word;
          });

          var incrementBetweenWords = (endTime - startTime) / textArray.length;
          return textArray
            .map(function (word, index) {
              return {
                text: word + ' ',
                startTime: startTime + incrementBetweenWords * index,
                endTime: (startTime + incrementBetweenWords * (index + 1)) - 0.01
              };
            });

        }

        function onPaste(event) {
          event.preventDefault();

          if (ctrl.isTranscriptionRowDisabled) {
            return;
          }

          if (updateTimeout) {
            $timeout.cancel(updateTimeout);
          }

          var selectedElements = getselectedElements();

          var pastedData = event.originalEvent.clipboardData.getData('text');

          var leftElements = $.makeArray(selectedElements[0].prevAll().children()).reverse();
          var rightElements = $.makeArray(selectedElements[selectedElements.length - 1].nextAll().children());

          var leftWords = getWordArray(leftElements);
          var rightWords = getWordArray(rightElements);

          var middleStartTime = leftWords.length ? leftWords[leftWords.length - 1].endTime : rightWords[0].startTime;
          var middleEndTime = rightWords.length ? rightWords[0].startTime : leftWords[leftWords.length - 1].endTime;

          var middleWords = getTimecodedWords(pastedData, middleStartTime, middleEndTime);

          var allWords = leftWords.concat(middleWords, rightWords);

          ctrl.transcriptionObject.words = allWords;
          ctrl.transcriptionObject.endTime = allWords[allWords.length - 1].endTime;

          ctrl.onTranscriptionWordsChange({words: allWords, refresh: false});

          $timeout(function () {
            setCaretPosition(element[0], leftWords.length + middleWords.length - 2, false);
          });
        }

        function onEditableContentChange() {
          if (ctrl.isTranscriptionRowDisabled) {
            return;
          }

          if (updateTimeout) {
            $timeout.cancel(updateTimeout);
          }

          updateTimeout = $timeout(function () {
            // TODO: make sure to execute this before to leave the app.

            notifyWordsUpdate();

          }, updateDelayInMilliseconds);

        }

        function notifyWordsUpdate() {
          var wordElementArray = $.makeArray(element.find('.transcription-word'));
          var wordArray = getWordArray(wordElementArray);
          ctrl.onTranscriptionWordsChange({words: wordArray});
        }

        function onKeyUp(e) {
          down = false;
        }

        function onKeyDown(e) {
          if (down || ctrl.isTranscriptionRowDisabled) {
            return;
          }

          down = true;

          var BACKSPACE_KEYCODE = 8;
          var ENTER_KEYCODE = 13;
          var ARROW_DOWN = 40;
          var ARROW_UP = 38;

          var keyCode = e.keyCode ? e.keyCode : e.which;

          if (keyCode === ENTER_KEYCODE) {
            e.preventDefault();

            if (updateTimeout) {
              $timeout.cancel(updateTimeout);
            }

            var wordElementBeforeNewLineArray = $.makeArray(getFirstElementOfNewRow().parent().prevAll().children()).reverse();

            if (e.shiftKey) {
              var previousWordSpan = getFirstElementOfNewRow().parent().prev().children().first();
              if (previousWordSpan && previousWordSpan[0]) {
                previousWordSpan[0].innerHTML = previousWordSpan[0].innerHTML + '\n';

                $timeout(function () {
                  setCaretPosition(element[0], wordElementBeforeNewLineArray.length, true);
                });

                notifyWordsUpdate();
              }

            } else {
              var wordArray = getWordArray(wordElementBeforeNewLineArray);
              if (wordArray.length) {
                var newWordElementArray = $.makeArray(getFirstElementOfNewRow().parent().nextAll().children());
                newWordElementArray.unshift(getFirstElementOfNewRow()[0]);
                var newWordArray = getWordArray(newWordElementArray);

                ctrl.transcriptionObject.words = wordArray;
                ctrl.transcriptionObject.endTime = wordArray[wordArray.length - 1].endTime;

                ctrl.onTranscriptionWordsChange({words: wordArray, refresh: true});

                if (newWordArray.length) {
                  ctrl.onTranscriptionWordsCreate({words: newWordArray});
                }
              }
            }

          }

          if (keyCode === BACKSPACE_KEYCODE) {
            if(isCursorAtTheBeginningOfParagraph()) {
              e.preventDefault();
              if (updateTimeout) {
                $timeout.cancel(updateTimeout);
              }

              $timeout(function () {
                // Updating model with changes in the dom. No Angularjs style due to the binding does not work with contenteditable and nested children
                var wordElementArrayToDelete = $.makeArray(element.find('.transcription-word'));
                var wordArrayToDelete = getWordArray(wordElementArrayToDelete);

                var currentContainerElement = element.closest('.transcription-row');
                var previousElementWordArray = $.makeArray(currentContainerElement.prev().find('.transcription-word'));
                var previousWordArray = getWordArray(previousElementWordArray);

                ctrl.onTranscriptionWordsRemove({words: wordArrayToDelete, previousWords: previousWordArray});
              });

            }

          }

          var currentContainerElement = $(element).closest('.transcription-row');

          if (keyCode === ARROW_UP && isCursorAtTheBeginningOfParagraph()) {
            var previousParagraphElement = currentContainerElement.prev().find('.transcription-paragraph');
            $timeout(function () {
              if (previousParagraphElement[0] && $(previousParagraphElement).find('.transcription-word')[0]) {
                setCaretPosition(previousParagraphElement[0], 0, true);
              }
            });
          }

          if (keyCode === ARROW_DOWN && isCursorAtTheEndOfParagraph()) {
            var nextParagraphElement = currentContainerElement.next().find('.transcription-paragraph');
            $timeout(function () {
              if (nextParagraphElement[0] && $(nextParagraphElement).find('.transcription-word')[0]) {
                setCaretPosition(nextParagraphElement[0], 0, true);
              }
            });
          }

        }

        function setCaretPosition(elem, caretPos, atStart) {
          if (elem) {
            caretPos = caretPos || 0;

            var wordsElements = $.makeArray($(elem).find('.transcription-word'));
            if (wordsElements[caretPos]) {
              createCaretPlacer($(wordsElements[caretPos]), true, atStart);
            } else {
              elem.focus();
            }
          }

        }

        function createCaretPlacer($element, collapse, atStart) {
          var el = $element[0]; // get the dom node of the given element
          el.focus(); // focus to the element
          // feature test to see which methods to use for given browser
          if (typeof window.getSelection != 'undefined' && typeof document.createRange != 'undefined') {
            // handle real browsers (not IE)
            var range = document.createRange(); // create a new range object
            range.selectNodeContents(el); // add the contents of the given element to the range
            if(collapse) {range.collapse(atStart);} // collapse the rage to either the first or last index based on "atStart" param
            var sel = window.getSelection(); // Returns a Selection object representing the range of text selected by the user or the current position of the caret.
            sel.removeAllRanges(); // removes all ranges from the selection, leaving the anchorNode and focusNode properties equal to null and leaving nothing selected.
            sel.addRange(range); // add the range we created to the selection effectively setting the cursor position
          } else if (typeof document.body.createTextRange != 'undefined') {
            // handle IE
            var textRange = document.body.createTextRange();
            textRange.moveToElementText(el);
            if(collapse) {textRange.collapse(atStart);}
            textRange.select();
          }
        }

        function getWordArray(wordElementArray) {
          return wordElementArray.map(function (elementItem) {
            var whitelistToPreserve = ['br', 'div'];
            var textWithoutNgBindTags = window.striptags(elementItem.innerHTML, whitelistToPreserve);
            textWithoutNgBindTags = stringHelperService.convertHtmlToText(textWithoutNgBindTags);
            return {
              text: textWithoutNgBindTags,
              startTime: elementItem.getAttribute('data-startTime'),
              endTime: elementItem.getAttribute('data-endTime')
            };
          });
        }

        function getElementWithCursor() {
          var node = document.getSelection().anchorNode;
          return node.nodeType === 3 ? node.parentNode : node;
        }

        function getselectedElements() {
          var anchorNode = document.getSelection().anchorNode;
          var startNode = anchorNode.nodeType === 3 ? anchorNode.parentNode : anchorNode;
          var startNodeContainer = $(startNode).closest('.transcription-word-container');

          var extentNode = document.getSelection().extentNode;
          var endNode = extentNode.nodeType === 3 ? extentNode.parentNode : extentNode;
          var endNodeContainer = $(endNode).closest('.transcription-word-container');

          var elements = [];
          var currentContainer;

          do {
            currentContainer = currentContainer ? currentContainer.next() : startNodeContainer
            elements.push(currentContainer);
          }
          while(currentContainer[0] != endNodeContainer[0] && currentContainer && endNodeContainer);

          return elements;
        }

        function isCursorAtTheBeginningOfParagraph() {
          var elementWithCurrentCursor = getElementWithCursor();
          return document.getSelection().isCollapsed && document.getSelection().anchorOffset === 0 && isFirstChildElementInTheParagraph(elementWithCurrentCursor);
        }

        function isCursorAtTheEndOfParagraph() {
          var elementWithCurrentCursor = getElementWithCursor();
          var textWithoutLineBreaksAtTheEnd = $(elementWithCurrentCursor).text().replace(/\r?\n|\r+$/g, '');
          return document.getSelection().isCollapsed && isLastChildElementInTheParagraph(elementWithCurrentCursor) && document.getSelection().anchorOffset >= textWithoutLineBreaksAtTheEnd.length;
        }

        function isFirstChildElementInTheParagraph(elementWithCurrentCursor) {
          return elementWithCurrentCursor.nodeName === 'P' || !$(elementWithCurrentCursor).closest('.transcription-word-container').prev().length;
        }

        function isLastChildElementInTheParagraph(elementWithCurrentCursor) {
          return !$(elementWithCurrentCursor).closest('.transcription-word-container').next().length;
        }

        function getFirstElementOfNewRow() {
          var node = document.getSelection().anchorNode;
          var elementWithCurrentCursor =  node.nodeType === 3 ? node.parentNode : node;

          var wordSpanElement;

          if (elementWithCurrentCursor.nodeName === 'NG-BIND-HTML') {
            wordSpanElement = $(elementWithCurrentCursor).closest('span');
          } else {
            wordSpanElement = $(elementWithCurrentCursor);
          }

          if (document.getSelection().anchorOffset === 0) {
            return wordSpanElement;
          }
          return wordSpanElement.parent().next().children().first();
        }

      }
    };
  }

  TranscriptionRowController.$inject = [];

  function TranscriptionRowController() {
    var me = this;

    me.$onInit = onInit;

    function onInit() {}
  }

})();


(function () {
  'use strict';
  angular
    .module('ai.simonCommonUi')
    .directive('transcriptionRowDomFilter', transcriptionRowDomFilter);

  transcriptionRowDomFilter.$inject = [];

  function transcriptionRowDomFilter() {
    return {
      restrict: 'A',
      scope: {},
      bindToController: {
        textToSearch: '<transcriptionRowDomFilter'
      },
      controller: TranscriptionRowController,
      controllerAs: '$ctrl',
      link: function (scope, element, attr, ctrl) {
      }
    };
  }

  TranscriptionRowController.$inject = ['$element', '$timeout'];

  function TranscriptionRowController($element, $timeout) {
    var me = this;
    var showTranscript = true;

    me.$onInit = onInit;
    me.$onChanges = onChanges;

    function onInit() {
    }

    function onChanges(changesObj) {

      if (changesObj.textToSearch) {
        $timeout(function () {
          showTranscript = me.textToSearch && elementContainsText() || !me.textToSearch;

          if (!showTranscript) {
            $element.hide();
          } else {
            $element.show();
          }
        });
      }

    }

    function elementContainsText() {
      var text = $element.find('.transcription-paragraph').text().toLowerCase();
      var textToSearch = me.textToSearch.toLowerCase();
      return text && text.includes(textToSearch);
    }
  }

})();


(function () {
    'use strict';
    angular
        .module('ai.simonCommonUi')
        .directive('autoFocus', autoFocusDirective);

    autoFocusDirective.$inject = ['$timeout'];

    function autoFocusDirective($timeout) {
        return {
            restrict: 'A',

            link: function (scope, element, attrs) {
                scope.$watch(attrs.autoFocus, function (val) {
                    if (angular.isDefined(val) && val) {
                        $timeout(function () {
                            element.focus();
                        });
                    }
                }, true);
            }
        };
    }

})();




(function () {
    'use strict';

    angular
        .module('ai.simonCommonUi')
        .directive('autoScroll', autoScroll);

    autoScroll.$inject = ['$timeout', '$window'];

    /* @ngInject */
    function autoScroll($timeout, $window) {
        return {
            link: link,
            restrict: 'A'
        };

        function link(scope, element, attrs) {
            var scrollDuration = 300;
            scope.$watch(
                function() {
                    return scope.$eval(attrs.autoScroll);
                },
                function(value) {
                    if (value) {
                        var eTop = $(element).offset().top;
                        var offset = scope.$eval(attrs.autoScrollOffset) || 0;
                        var yPosition = eTop - offset;

                        var onStartAutoScroll = scope.$eval(attrs.onStartAutoScroll);
                        if (angular.isFunction()) {
                            $timeout(function() {
                                onStartAutoScroll();
                            });
                        }

                        var myScroller = zenscroll;
                        var scrollableElement = attrs.scrollableSelector ? angular.element(attrs.scrollableSelector)[0] : null;
                        if (scrollableElement) {
                          myScroller = zenscroll.createScroller(scrollableElement, scrollDuration);
                        }

                        myScroller.toY(yPosition, scrollDuration, function () {
                            $timeout(function () {
                                var onFinishAutoScroll = scope.$eval(attrs.onFinishAutoScroll, {$yPosition: yPosition});
                                if (angular.isFunction(onFinishAutoScroll)) {
                                    onFinishAutoScroll();
                                }
                            }, 100);
                        });
                    }
                }
            );
        }
    }

})();


(function () {
    'use strict';

    angular
        .module('ai.simonCommonUi')
        .constant('SPEAKER_COLORS', [
            {
                color: '#b189d5',
                label: '#FFF'
            },
            {
                color: '#C5E098',
                label: '#FFF'
            },
            {
                color: '#FFC873',
                label: '#FFF'
            },
            {
                color: '#62C6E7',
                label: '#FFF'
            },
            {
                color: '#778FC5',
                label: '#FFF'
            },
            {
                color: '#838383',
                label: '#FFF'
            },
            {
                color: '#553B75',
                label: '#FFF'
            },
            {
                color: '#C3EDFB',
                label: '#1D9AC3'
            },
            {
                color: '#BF8224',
                label: '#FFE7C2'
            },
            {
                color: '#E0F1C3',
                label: '#769939'
            }

        ]);
})();

(function () {
    'use strict';

    angular
        .module('ai.simonCommonUi')
        .constant('PROJECT_TRANSCRIBING_SHORTCUTS', {
            PLAY_PAUSE: {
                combo: 'ctrl+space',
                description: 'Play/Pause.',
                allowIn: ['INPUT', 'TEXTAREA']
            },
            REWIND: {
                combo: 'mod+left',
                description: 'Go back 5 seconds.',
                allowIn: ['INPUT', 'TEXTAREA']
            },
            FAST_FORWARD: {
                combo: 'mod+right',
                description: 'Go forward 5 seconds.',
                allowIn: ['INPUT', 'TEXTAREA']
            },
            PREVIOUS_TRANSCRIPTION: {
                combo: 'mod+up',
                description: 'Go to the previous transcript row.',
                allowIn: ['INPUT', 'TEXTAREA']
            },
            NEXT_TRANSCRIPTION: {
                combo: 'mod+down',
                description: 'Go to the next transcript row.',
                allowIn: ['INPUT', 'TEXTAREA']
            },
            BOOKMARK: {
                combo: 'ctrl+b',
                description: 'Bookmark.',
                allowIn: ['INPUT', 'TEXTAREA']
            },
            NEW_PARAGRAPH: {
                combo: 'shift+enter',
                description: 'Create new paragraph line.',
                allowIn: ['INPUT', 'TEXTAREA']
            },
            NEW_ROW: {
                combo: 'enter',
                description: 'Create a new row.',
                allowIn: ['INPUT', 'TEXTAREA']
            },
            GO_TO_WORD_TIMECODE: {
                combo: 'mod+mouse-click',
                description: 'Goes to that timecode point in the audio / video.',
                allowIn: ['INPUT', 'TEXTAREA']
            },
            SPEED_UP_PLAYBACK: {
                combo: 'ctrl+.',
                description: 'Increase playback speed.',
                allowIn: ['INPUT', 'TEXTAREA']
            },
            SLOW_DOWN_PLAYBACK: {
                combo: 'ctrl+,',
                description: 'Decrease playback speed.',
                allowIn: ['INPUT', 'TEXTAREA']
            }
        });
})();

(function () {
  'use strict';

  angular
    .module('thirdPartyLibraries', [
      'cfp.hotkeys',
      'com.2fdevs.videogular',
      'com.2fdevs.videogular.plugins.controls',
      'com.2fdevs.videogular.plugins.overlayplay',
      'com.2fdevs.videogular.plugins.poster',
      'com.2fdevs.videogular.plugins.buffering',
      'ngSanitize',
      'timer',
      'ui.bootstrap',
      'uk.ac.soton.ecs.videogular.plugins.cuepoints'
    ]);

})();

(function () {
  'use strict';
  angular
    .module('ai.simonCommonUi')
    .config(config);

  config.$inject = ['hotkeysProvider'];

  function config(hotkeysProvider) {
    hotkeysProvider.templateFooter = '' +
    '<div class="smart-commands-help-footer">' +
    '<h4 class="cfp-hotkeys-title"> What can I do on this page? </h4>' +
    '<ol>\n' +
    '    <li> Play your media and adjust the playback speed, edit the text, and add speaker labels.</li>\n' +
    '    <li> Export your transcript.</li>\n' +
    '    <li> Share your project with your team ' +
        '(monthly subscription required; contact us to activate the feature).</li>\n' +
    '    <li> Synchronize timecode.</li>\n' +
    '    <li> Search for keywords, bookmark rows, and annotate.</li>\n' +
    '</ol>' +
    '</div>';
  }
})();

angular.module("ai.simonCommonUi").run(["$templateCache", function($templateCache) {$templateCache.put("components/mini-player/mini-player.component.html","<div class=\"mini-player\"><div class=\"control-item play-pause-button\" title=\"{{ $ctrl.trackState.isPlaying ? \'Pause\' : \'Play\'}}\" ng-class=\"{\'is-playing\': $ctrl.trackState.isPlaying}\" ng-click=\"$ctrl.onClickPlayPause({$event: $event}); $event.target.blur();\"></div><div class=\"volume-container\" title=\"Volume\" ng-click=\"$ctrl.onClickVolume({$event: $event}); $event.target.blur();\"><svg width=\"100%\" height=\"100%\" viewBox=\"0 0 40 40\" class=\"donut\"><circle class=\"donut-hole\" cx=\"20\" cy=\"20\" r=\"15.91549430918954\" fill=\"#fff\"></circle><circle class=\"donut-ring\" cx=\"20\" cy=\"20\" r=\"15.91549430918954\" fill=\"transparent\" stroke=\"#d2d3d4\" stroke-width=\"5\"></circle><circle class=\"donut-segment\" cx=\"20\" cy=\"20\" r=\"15.91549430918954\" fill=\"transparent\" stroke-width=\"5\" ng-if=\"$ctrl.getVolumeCirclePercentage()\" stroke-dasharray=\"{{ $ctrl.getVolumeCirclePercentage() }} {{ 100 - $ctrl.getVolumeCirclePercentage() }}\" stroke-dashoffset=\"33.33\"></circle><foreignobject class=\"node\" x=\"0\" y=\"0\" width=\"100%\" height=\"100%\"><div class=\"control-item volume-button\" ng-class=\"{\'is-muted\': $ctrl.isMuted()}\"></div></foreignobject></svg></div><div class=\"control-item bookmark-control\"><span class=\"fa fa-caret-left\" title=\"Previous bookmark\" ng-click=\"$ctrl.onClickPreviousBookmark({$event: $event}); $event.target.blur();\"></span><span ng-click=\"$ctrl.onClickBookmark(); $event.target.blur();\" title=\"Bookmark\" ng-class=\"{\'disabled\': $ctrl.isPublicPageView}\" class=\"bookmark-icon fa fa-bookmark\"></span><span class=\"fa fa-caret-right\" title=\"Next bookmark\" ng-click=\"$ctrl.onClickNextBookmark({$event: $event}); $event.target.blur();\"></span></div><div class=\"control-item control-item-video\" title=\"Show/Hide Video\" ng-class=\"{\'selected\': !$ctrl.isVideoHidden()}\" ng-show=\"$ctrl.isVideo()\" ng-click=\"$ctrl.onClickVideo({$event: $event}); $event.target.blur();\"><i class=\"fa fa-video-camera\"></i></div><div ng-click=\"$ctrl.onClickChangePlaySpeed({$event: $event}); $event.target.blur();\" title=\"Playback speed\" class=\"control-item play-speed\">{{ $ctrl.trackState.playSpeed || \'1\' }}x</div></div>");
$templateCache.put("components/animated-logo/animated-logo.component.html","<a title=\"Home\" class=\"logo-link-container\" ng-href=\"{{ $ctrl.logoHref }}\" target=\"{{ $ctrl.inIframe() ? \'_blank\' : \'\' }}\"><span class=\"logo parrot-eye-container\"><div class=\"parrot-eye\"></div></span><span class=\"logo logo-close-eye\">Simon Says</span></a>");
$templateCache.put("components/plain-logo/plain-logo.component.html","<a title=\"Home\" class=\"logo-link-container\" ng-href=\"{{ $ctrl.logoHref }}\" target=\"{{ $ctrl.inIframe() ? \'_blank\' : \'\' }}\"><span class=\"logo plain-logo\">Logo</span></a>");
$templateCache.put("components/project-transcripts/project-transcripts.component.html","<div class=\"project-view\"><div><nav use-sticky is-sticky-active=\"$ctrl.isStickyActive\" class=\"main-app-header-container transcribing-header\" ng-class=\"{\'with-search-input-open\': $ctrl.userSearch.value || $ctrl.searchInput.isOpen}\"><div class=\"container-fluid\"><div class=\"pull-left\"><div class=\"main-app-header-item home-item\"><a ng-click=\"$ctrl.onClickHome()\" ng-if=\"!$ctrl.hideHome && !$ctrl.inIframe()\"><i class=\"fa fa-home\"></i></a></div></div><div class=\"pull-left central-section-ps4-header\" ng-class=\"{\n                        \'without-toolbar\': !$ctrl.isTeamMember && !$ctrl.isProjectOwner && !$ctrl.isAdmin,\n                        \'with-multiple-files\': $ctrl.medias.length > 1\n                    }\"><div class=\"main-app-header-item main-app-header-item-project-name\"><div class=\"editable-project-name\" title=\"{{ $ctrl.project.name }}\" ng-if=\"$ctrl.isProjectOwner\" ng-class=\"{\'project-name-placeholder\': !$ctrl.project.name}\" contenteditable=\"true\" editable-content data-text-placeholder=\"[Insert Project Name]\" ng-change=\"$ctrl.updateProject()\" ng-model=\"$ctrl.project.name\"></div><div class=\"project-name-in-toolbar\" title=\"{{ $ctrl.project.name }}\" ng-class=\"{\n                                \'without-toolbar\': !$ctrl.isTeamMember && !$ctrl.isProjectOwner && !$ctrl.isAdmin\n                             }\" ng-if=\"!$ctrl.isProjectOwner\"><span ng-bind-html=\"$ctrl.project.name\"></span></div><div class=\"owner-email\" ng-if=\"$ctrl.isTeamMember && !$ctrl.isProjectOwner\">Owner:<span class=\"created-video\">{{ $ctrl.project.owner.email }}</span></div></div></div><div ng-if=\"!$ctrl.hideShareButton && $ctrl.isProjectOwner\" class=\"pull-left toolbar-file-item share-project-header-icon-container\"><div class=\"main-app-header-item main-app-toolbar-item\" title=\"{{ $ctrl.isProjectOwner ? \'Share Project\' : \'You can\\\'t share the project as you are not the owner.\' }}\" ng-click=\"$ctrl.onClickShareButton()\" ng-class=\"{\'disabled\': !$ctrl.isProjectOwner, \'selected\': $ctrl.isProjectShared || $ctrl.isProjectPublished}\"><span><img class=\"share-project-image\" src=\"./img/Ei-share-apple.svg.png\" alt=\"Share\"></span></div></div><div class=\"pull-left main-app-header-item-file-name-container\"><div class=\"main-app-header-item main-app-header-item-file-name\" ng-class=\"{\'align-as-public\': !$ctrl.isTeamMember && !$ctrl.isProjectOwner}\"><span class=\"media-read-only-info-icon\" title=\"This file is locked for editing as it is currently being worked on by your colleague.\" ng-if=\"$ctrl.isTeamMember && $ctrl.isCurrentMediaLockByOtherUser\"><a ng-click=\"$ctrl.forceLock()\"><i class=\"fa fa-lock\"></i></a></span><span uib-dropdown dropdown-append-to-body is-open=\"$ctrl.mediaFileDropdown.isopen\" ng-if=\"$ctrl.medias.length > 1\"><span class=\"dropdown-label\" uib-dropdown-toggle><span title=\"{{ $ctrl.currentMedia.name }}\" ng-class=\"{\n                                        \'with-search-input-open\': $ctrl.userSearch.value || $ctrl.searchInput.isOpen,\n                                        \'without-toolbar\' : !$ctrl.isTeamMember && !$ctrl.isProjectOwner && !$ctrl.isAdmin\n                                    }\" auto-max-width-element auto-width-element-offset=\"550\" auto-width-cointainer=\"\'.container-fluid\'\" auto-width-siblings=\"[\'.main-app-header-item.main-app-header-item-project-name\', \'.pull-right.toolbar-file-item.transcription-input-search-container\']\" class=\"media-file-name\">{{ $ctrl.currentMedia.name }}<i class=\"fa fa-caret-down\" aria-hidden=\"true\"></i></span></span><ul class=\"dropdown-menu dropdown-menu-filename\" uib-dropdown-menu aria-labelledby=\"language-dropdown\"><li ng-repeat=\"media in $ctrl.medias\" title=\"{{ media.name }}\" ng-class=\"{\'selected-item-file\': media.id === $ctrl.currentMedia.id}\"><a ng-if=\"media.id === $ctrl.currentMedia.id\">{{ media.name | middleEllipses : 35 : \' ... \' }}</a><a ng-if=\"media.id !== $ctrl.currentMedia.id\" ng-click=\"$ctrl.onSelectMedia(media)\">{{ media.name | middleEllipses : 35 : \' ... \' }}</a></li></ul></span><span title=\"{{ $ctrl.currentMedia.name }}\" auto-max-width-element auto-width-element-offset=\"550\" auto-width-cointainer=\"\'.container-fluid\'\" auto-width-siblings=\"[\'.main-app-header-item.main-app-header-item-project-name\', \'.pull-right.toolbar-file-item.transcription-input-search-container\']\" ng-if=\"($ctrl.isTeamMember || $ctrl.isProjectOwner) && $ctrl.medias.length === 1\" ng-class=\"{\n                                \'with-search-input-open\': $ctrl.userSearch.value || $ctrl.searchInput.isOpen,\n                                \'without-toolbar\' : !$ctrl.isTeamMember && !$ctrl.isProjectOwner && !$ctrl.isAdmin\n                              }\" class=\"media-file-name\">{{ $ctrl.currentMedia.name }}</span></div></div><div class=\"pull-right export-button-container\" ng-show=\"($ctrl.isTeamMember || $ctrl.isProjectOwner || $ctrl.isAdmin) && $ctrl.canExportCurrentMedia()\"><button type=\"button\" class=\"transcribe-button main-button\" ng-class=\"{\'no-media\': !$ctrl.canExportCurrentMedia(), \'wiggled-button\': $ctrl.canExportCurrentMedia()}\" ng-click=\"$ctrl.onClickExportButton({currentMedia: $ctrl.currentMedia})\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i>Export</button></div><div class=\"pull-right export-button-container\" ng-show=\"$ctrl.canExportProject() && $ctrl.canMergeTracks()\"><button type=\"button\" class=\"transcribe-button main-button\" ng-class=\"{\'no-media\': !$ctrl.canExportProject()}\" ng-click=\"$ctrl.onClickMergeTracksButton()\"><i class=\"fa fa-wrench\" aria-hidden=\"true\"></i>Merge Tracks</button></div><div ng-if=\"($ctrl.isTeamMember || $ctrl.isProjectOwner || $ctrl.isAdmin) && $ctrl.canExportCurrentMedia()\" class=\"pull-left toolbar-file-item export-header-icon-container\"><div class=\"main-app-header-item main-app-toolbar-item\" title=\"Export\" ng-click=\"$ctrl.onClickExportButton({currentMedia: $ctrl.currentMedia})\"><span><i class=\"fa fa-download\"></i></span></div></div><div class=\"pull-right hidden-xs\" ng-show=\"$ctrl.isCurrentMediaTranscribing()\"><button class=\"transcribe-button processing-message transcribing-message main-button\"><span class=\"uploading-processing-spinner\" us-spinner=\"{radius:8, width:4, length: 5}\"></span><span>Transcribing...</span><div class=\"remaining-time-container\"><span class=\"remaining-time-label\">Time Remaining:</span><timer end-time=\"$ctrl.endTimeForTranscribing\" ng-if=\"$ctrl.endTimeForTranscribing\" class=\"remaining-timer\" start-callback=\"$ctrl.onTimerStarted()\" finish-callback=\"$ctrl.onTimerFinished()\" interval=\"1000\">{{ hours ? hours + \':\' : \'\'}}{{ (hours ? mminutes : minutes) + \':\' }}{{sseconds}}.</timer><span ng-if=\"$ctrl.endTimeForTranscribing\" class=\"countdown-decimal-seconds\">{{ $ctrl.countdownDecimalSeconds }}</span></div></button></div><div class=\"pull-right file-navigator-header-menu\" ng-if=\"$ctrl.medias.length > 1\"><div class=\"main-app-header-item\"><i ng-click=\"$ctrl.goToPreviousTranscriptFile()\" ng-class=\"{\'disabled\': !($ctrl.getCurrentMediaIndex() > 0)}\" class=\"fa fa-caret-left file-arrows\"></i><i title=\"files\" class=\"fa fa-file-audio-o file-icon\"></i><i ng-click=\"$ctrl.goToNextTranscriptFile()\" ng-class=\"{\'disabled\': !($ctrl.medias.length > 1 && $ctrl.getCurrentMediaIndex() < $ctrl.medias.length - 1)}\" class=\"fa fa-caret-right file-arrows\"></i></div></div><div ng-if=\"!$ctrl.isPublicPageView || $ctrl.isAdmin\" class=\"pull-right toolbar-file-item transcription-input-search-container hidden-xs\"><div ng-click=\"$ctrl.searchInput.isOpen = true\" class=\"main-app-header-item main-app-header-item-with-separator main-app-toolbar-item\"><span><i class=\"fa fa-search\"></i></span></div><input type=\"text\" auto-focus=\"$ctrl.searchInput.isOpen\" ng-show=\"$ctrl.userSearch.value || $ctrl.searchInput.isOpen\" ng-blur=\"$ctrl.searchInput.isOpen = false\" ng-model=\"$ctrl.userSearch.value\" class=\"transcription-input-search\"></div><div ng-if=\"!$ctrl.isPublicPageView || $ctrl.isAdmin\" class=\"pull-right toolbar-file-item hidden-xs\"><div class=\"main-app-header-item main-app-header-item-with-separator main-app-toolbar-item\" ng-click=\"$ctrl.toggleCheatSheet()\" title=\"Keyboard Shortcuts\"><span><i class=\"fa fa-question-circle-o\"></i></span></div></div><div ng-if=\"!$ctrl.hideTimecodeButton && (!$ctrl.isPublicPageView || $ctrl.isAdmin)\" class=\"pull-right toolbar-file-item hidden-xs\"><div class=\"main-app-header-item main-app-header-item-with-separator main-app-toolbar-item\" ng-class=\"{\'disabled\': $ctrl.isCurrentMediaLockByOtherUser}\" popover-enable=\"!$ctrl.isCurrentMediaLockByOtherUser\" uib-popover-template=\"\'timecodePopoverTemplate.html\'\" popover-is-open=\"$ctrl.popoverTimecode.isOpen\" popover-trigger=\"\'outsideClick\'\" popover-class=\"timecode-popover\" popover-placement=\"bottom\" title=\"Edit timecode\"><span><i class=\"fa fa-clock-o\" aria-hidden=\"true\"></i></span></div></div><div class=\"pull-right toolbar-file-item hidden-xs\"><div class=\"main-app-header-item main-app-header-item-with-separator main-app-toolbar-item\" ng-click=\"$ctrl.toggleNotesFilter($event); $event.target.blur();\" title=\"Annotation Filter\" ng-class=\"{\'selected\':$ctrl.showOnlyAnnotations}\"><span><i class=\"fa fa-sticky-note-o\"></i></span></div></div><div class=\"pull-right toolbar-file-item hidden-xs\"><div class=\"main-app-header-item main-app-header-item-with-separator main-app-toolbar-item\" ng-click=\"$ctrl.toggleBookmarkOnly($event); $event.target.blur();\" title=\"Bookmark Filter\" ng-class=\"{\'selected\': $ctrl.showOnlyBookmarks}\"><span><i class=\"fa fa-bookmark-o\"></i></span></div></div></div><div class=\"container-fluid sound-wave-container-fluid\"><wave-surfer ng-if=\"$ctrl.showWaveSurfer\" wave-surfer-instance=\"$ctrl.waveSurfer.instance\" bookmarks-in-seconds=\"$ctrl.waveFormBookmarksInSeconds\" wave-audio-url=\"{{ $ctrl.waveSurfer.audioUrl }}\" wave-peaks=\"$ctrl.waveSurfer.peaks\" time-code-offset=\"$ctrl.mediaTimecode.time\" wave-surfer-options=\"$ctrl.waveSurfer.options\"></wave-surfer></div></nav><div class=\"project-transcription container-fluid\"><div class=\"video-player-container with-sound-wave\" ng-class=\"{\n                    \'sticky-active\': $ctrl.isStickyActive\n                 }\" ng-show=\"$ctrl.currentMedia.type === \'video\' && $ctrl.showVideo\"><div ng-if=\"$ctrl.isCurrentVideoMediaTranscoding()\" class=\"simon-progress-bar-content video-transcoding-progress\">Your video is converting.<div class=\"minimize-video-button\" ng-click=\"$ctrl.toggleVideoVisibility()\"><i class=\"fa fa-angle-down\"></i></div></div><div class=\"videogular-container\" ng-class=\"{\'videogular-audio-container\': $ctrl.currentMedia.type === \'audio\'}\"><div class=\"transcoded-video-progress-container\" ng-show=\"$ctrl.currentMedia.type === \'video\' && $ctrl.config.sourceType === \'audio\'\"><round-progress class=\"real-progress\" max=\"100\" current=\"$ctrl.currentMedia.transcodedVideoProgressPercentage\" color=\"#7e56a2\" bgcolor=\"#B4B4B4\" radius=\"52\" stroke=\"5\" semi=\"false\" rounded=\"true\" clockwise=\"true\" responsive=\"false\" duration=\"800\" animation=\"easeInOutQuart\" animation-delay=\"0\"></round-progress></div><videogular vg-player-ready=\"$ctrl.onPlayerReady($API)\" vg-native-fullscreen=\"false\" vg-plays-inline=\"true\" vg-complete=\"$ctrl.onCompleteVideo()\" vg-update-time=\"$ctrl.onUpdateVideoTime($currentTime, $duration)\" vg-update-state=\"$ctrl.onUpdateState($state)\" vg-update-volume=\"$ctrl.onUpdateVolume($volume)\" vg-theme=\"$ctrl.config.theme.url\"><div class=\"minimize-video-button\" ng-click=\"$ctrl.toggleVideoVisibility()\"><i class=\"fa fa-angle-down\"></i></div><span class=\"media-source-container\"><vg-media vg-src=\"$ctrl.config.sources\" ng-if=\"$ctrl.config.sourceType !== \'audio\'\" vg-tracks=\"$ctrl.config.tracks\"></vg-media><vg-media vg-src=\"$ctrl.config.sources\" ng-if=\"$ctrl.config.sourceType === \'audio\'\" vg-type=\"audio\" vg-tracks=\"$ctrl.config.tracks\"></vg-media></span><div class=\"mobile-media-source-container\"><vg-media vg-src=\"$ctrl.config.sources\" vg-type=\"audio\" vg-tracks=\"$ctrl.config.tracks\"></vg-media></div><vg-controls><vg-play-pause-button></vg-play-pause-button><vg-time-display class=\"current-time-display\"><span ng-show=\"$ctrl.videoTime(currentTime)[\'_data\'].hours > 0 || $ctrl.videoTime(currentTime)[\'_data\'].days > 0\">{{ $ctrl.videoTime(currentTime)[\'_data\'].hours+($ctrl.videoTime(currentTime)[\'_data\'].days*24) >= 10 ? $ctrl.videoTime(currentTime)[\'_data\'].hours + ($ctrl.videoTime(currentTime)[\'_data\'].days * 24) : \'0\'+ $ctrl.videoTime(currentTime)[\'_data\'].hours }}:</span><span>{{ $ctrl.videoTime(currentTime)[\'_data\'].minutes >= 10 ? $ctrl.videoTime(currentTime)[\'_data\'].minutes : \'0\'+ $ctrl.videoTime(currentTime)[\'_data\'].minutes }}</span>:<span>{{ $ctrl.videoTime(currentTime)[\'_data\'].seconds >= 10 ? $ctrl.videoTime(currentTime)[\'_data\'].seconds : \'0\' + $ctrl.videoTime(currentTime)[\'_data\'].seconds }}</span></vg-time-display><vg-scrub-bar tooltip-follow-cursor=\"$ctrl.getTimeInBar($percentage)\"><vg-scrub-bar-current-time></vg-scrub-bar-current-time><vg-cuepoints vg-cuepoints-config=\"$ctrl.config.plugins.cuepoints\" vg-cuepoints-theme=\"$ctrl.config.plugins.cuepoints.theme.url\"></vg-cuepoints></vg-scrub-bar><vg-time-display ng-show=\"timeLeft\">{{ timeLeft | milliToTime }}</vg-time-display><vg-volume><vg-mute-button></vg-mute-button><vg-volume-bar></vg-volume-bar></vg-volume><vg-fullscreen-button ng-if=\"$ctrl.currentMedia.type === \'video\'\"></vg-fullscreen-button></vg-controls><vg-overlay-play ng-if=\"$ctrl.config.sourceType !== \'audio\'\"></vg-overlay-play><vg-buffering></vg-buffering><vg-poster ng-if=\"$ctrl.config.sourceType !== \'audio\'\" vg-url=\"$ctrl.config.plugins.poster\"></vg-poster></videogular></div><div ng-if=\"$ctrl.isPublicPageView && $ctrl.project.publicDescription\" class=\"public-project-description\">{{ $ctrl.project.publicDescription }}</div></div><div class=\"mini-player-container\" ng-class=\"{\n                    \'only-audio-player\': $ctrl.currentMedia.type === \'audio\' || !$ctrl.showVideo,\n                    \'sticky-active\': $ctrl.isStickyActive,\n                    \'is-public-page-view\': $ctrl.isPublicPageView\n                 }\"><mini-player is-public-page-view=\"$ctrl.isPublicPageView\" track-state=\"$ctrl.trackState\" on-click-previous-bookmark=\"$ctrl.goToPreviousTranscription(true, $event)\" on-click-next-bookmark=\"$ctrl.goToNextTranscription(true, $event)\" on-click-change-play-speed=\"$ctrl.changePlaySpeed(true, false, $event)\" on-click-volume=\"$ctrl.toggleVolumeState($event)\" on-click-video=\"$ctrl.toggleVideoVisibility($event)\" on-click-bookmark=\"$ctrl.bookmarkCurrentTranscription($event)\" on-change-volume=\"$ctrl.onChangeVolume($volumePercentage)\" on-click-play-pause=\"$ctrl.playPauseVideo($event)\"></mini-player></div><div class=\"main-app-header-container transcribing-header reduced-transcribing-header\" ng-class=\"{\n                    \'with-search-input-open\': $ctrl.userSearch.value || $ctrl.searchInput.isOpen,\n                    \'sticky-active\': $ctrl.isStickyActive\n                 }\"><div class=\"container-fluid\"><div ng-if=\"!$ctrl.isPublicPageView || $ctrl.isAdmin\" class=\"pull-right toolbar-file-item help-icon-container\"><div class=\"main-app-header-item main-app-header-item-with-separator main-app-toolbar-item\" title=\"Keyboard Shortcuts\" ng-click=\"$ctrl.toggleCheatSheet()\"><span><i class=\"fa fa-question-circle-o\"></i></span></div></div><div ng-if=\"!$ctrl.hideTimecodeButton && (!$ctrl.isPublicPageView || $ctrl.isAdmin)\" class=\"pull-right toolbar-file-item\"><div class=\"main-app-header-item main-app-header-item-with-separator main-app-toolbar-item\" ng-class=\"{\'disabled\': $ctrl.isCurrentMediaLockByOtherUser}\" popover-enable=\"!$ctrl.isCurrentMediaLockByOtherUser\" uib-popover-template=\"\'timecodePopoverTemplate.html\'\" popover-is-open=\"$ctrl.popoverTimecodeForMobile.isOpen\" popover-trigger=\"\'outsideClick\'\" popover-placement=\"right-top\" title=\"Edit timecode\"><span><i class=\"fa fa-clock-o\" aria-hidden=\"true\"></i></span></div></div><div class=\"pull-right toolbar-file-item\"><div class=\"main-app-header-item main-app-header-item-with-separator main-app-toolbar-item\" ng-click=\"$ctrl.toggleNotesFilter($event); $event.target.blur();\" title=\"Annotation Filter\" ng-class=\"{\'selected\': $ctrl.showOnlyAnnotations}\"><span><i class=\"fa fa-sticky-note-o\"></i></span></div></div><div class=\"pull-right toolbar-file-item\"><div class=\"main-app-header-item main-app-header-item-with-separator main-app-toolbar-item\" ng-click=\"$ctrl.toggleBookmarkOnly($event); $event.target.blur();\" title=\"Bookmark Filter\" ng-class=\"{\'selected\': $ctrl.showOnlyBookmarks}\"><span><i class=\"fa fa-bookmark-o\"></i></span></div></div></div></div><div class=\"transcriptions-list-container with-sound-wave\" ng-class=\"{\n                    \'only-audio-container\': $ctrl.currentMedia.type === \'audio\' || !$ctrl.showVideo,\n                    \'sticky-active\': $ctrl.isStickyActive\n                 }\"><div ng-if=\"$ctrl.isPublicPageView && $ctrl.project.publicDescription\" class=\"public-project-description\">{{ $ctrl.project.publicDescription }}</div><div ng-if=\"$ctrl.currentMedia.status !== \'failed\'\"><div class=\"transcriptions-list mousetrap\" ng-if=\"!$ctrl.isCurrentMediaTranslating()\"><div class=\"mousetrap resume-transcript-auto-scroll\" ng-class=\"{\'is-at-the-bottom\': $ctrl.isScrollAtTheBottom($ctrl.scrollContainerSelector)}\" ng-if=\"!$ctrl.isAutoScrollActive\" ng-click=\"$ctrl.turnOnAutoScroll()\"><i class=\"fa fa-sort-amount-desc\"></i>Resume Transcript Auto-Scroll</div><div class=\"transcription-row mousetrap\" transcription-row-dom-filter=\"$ctrl.userSearch.value\" ng-repeat=\"transcription in $ctrl.transcriptions\" ng-show=\"((transcription.bookmark && $ctrl.showOnlyBookmarks) || !$ctrl.showOnlyBookmarks) && ((transcription.annotation && $ctrl.showOnlyAnnotations) || !$ctrl.showOnlyAnnotations)\" auto-scroll=\"$ctrl.isAutoScrollActive && $ctrl.isPlaying(transcription.startTime, transcription.endTime)\" auto-scroll-offset=\"$ctrl.scrollContainerOffset\" on-start-auto-scroll=\"$ctrl.onStartAutoScroll()\" on-finish-auto-scroll=\"$ctrl.onFinishAutoScroll($yPosition)\" scrollable-selector=\"{{$ctrl.scrollContainerSelector}}\" ng-class=\"{\n                            \'playing\': $ctrl.isPlaying(transcription.startTime, transcription.endTime),\n                            \'bookmarked\': transcription.bookmark,\n                            \'rtl-transcriptions\': $ctrl.languageTextDirection === \'rtl\'\n                        }\"><div class=\"inner-toolbar inner-toolbar-left\" ng-if=\"!$ctrl.isCurrentMediaLockByOtherUser && !$ctrl.isPublicPageView\"><span class=\"fa bookmark-icon fa-bookmark{{ !transcription.bookmark ? \'-o\' : \'\' }}\" ng-class=\"{visible: $ctrl.openPopoverAnnotations[transcription.id] || transcription.bookmark}\" ng-click=\"$ctrl.bookmark(transcription)\"></span></div><div class=\"inner-toolbar inner-toolbar-right annotation-row\"><span ng-if=\"!$ctrl.isCurrentMediaLockByOtherUser && !$ctrl.isPublicPageView\" class=\"notes-icon fa fa-sticky-note{{ !transcription.annotation ? \'-o\' : \'\' }}\" ng-class=\"{visible: $ctrl.openPopoverAnnotations[transcription.id] || transcription.annotation}\" uib-popover-template=\"\'annotationPopoverTemplate.html\'\" popover-placement=\"{{ $ctrl.languageTextDirection === \'rtl\' ? \'left\' : \'right\' }}\" popover-is-open=\"$ctrl.openPopoverAnnotations[transcription.id]\" type=\"button\" ng-click=\"$ctrl.currentTranscription = transcription\" popover-trigger=\"\'outsideClick\'\"></span><span ng-class=\"{visible: transcription.annotation}\" ng-mouseover=\"$ctrl.currentTranscription = transcription; $ctrl.openPopoverAnnotations[transcription.id] = true;\" ng-mouseleave=\"$ctrl.openPopoverAnnotations[transcription.id] = false\"><spanf ng-if=\"$ctrl.isCurrentMediaLockByOtherUser || $ctrl.isPublicPageView\" class=\"notes-icon notes-icon-read-only fa fa-sticky-note\" uib-popover-template=\"\'readOnlyAnnotationPopoverTemplate.html\'\" popover-placement=\"{{ $ctrl.languageTextDirection === \'rtl\' ? \'left\' : \'right\' }}\" type=\"button\" popover-is-open=\"$ctrl.openPopoverAnnotations[transcription.id]\" popover-trigger=\"\'outsideClick\'\"></spanf></span></div><div class=\"transcription-data-container\"><div class=\"inner-toolbar speaker-container\" ng-if=\"$ctrl.currentMedia.status !== \'subtitled\'\"><div class=\"speaker\" title=\"{{ !$ctrl.isCurrentMediaLockByOtherUser && !$ctrl.isPublicPageView ? \'\' : transcription.speaker.name }}\" ng-class=\"{\'default-speaker\': !$ctrl.transcription.speaker, \'disabled\': ($ctrl.isCurrentMediaLockByOtherUser || $ctrl.isPublicPageView) && !transcription.speaker}\" ng-style=\"$ctrl.getSpeakerCssStyle(transcription.speaker)\" uib-popover-template=\"\'speakerTemplate.html\'\" popover-placement=\"{{ $ctrl.languageTextDirection === \'rtl\' ? \'left\' : \'right\' }}\" ng-click=\"$ctrl.currentTranscription = transcription\" popover-trigger=\"\'outsideClick\'\" popover-enable=\"(!$ctrl.isCurrentMediaLockByOtherUser && !$ctrl.isPublicPageView) || transcription.speaker\" popover-is-open=\"transcription.isSpeakerMenuOpen\">{{ transcription.speaker ? (transcription.speaker.name | initials) : $ctrl.getNoSpeakerSymbol() }}</div></div><div class=\"transcription-time\" ng-click=\"$ctrl.playTime(transcription.startTime, $event)\">{{ $ctrl.getFormattedTimestamp(transcription.startTime) }}</div><p ng-if=\"$ctrl.islanguageTextDirectionRTL === \'ltr\'\" class=\"transcription-paragraph mousetrap ltr-left\" style=\"text-align: left;\" ng-click=\"$ctrl.playWordTime($event)\" dir=\"auto\" contenteditable=\"{{ !!(!$ctrl.isCurrentMediaLockByOtherUser && !$ctrl.isPublicPageView && ($ctrl.isTeamMember || $ctrl.isProjectOwner)) }}\" on-transcription-words-change=\"$ctrl.onTranscriptionWordsChange(words, transcription, refresh)\" on-transcription-words-create=\"$ctrl.onTranscriptionWordsCreate(words, transcription)\" on-transcription-words-remove=\"$ctrl.onTranscriptionWordsRemove(words, previousWords, transcription)\" transcription-row-disabled=\"$ctrl.isCurrentMediaLockByOtherUser || $ctrl.isPublicPageView || (!$ctrl.isTeamMember && !$ctrl.isProjectOwner)\" transcription-row=\"transcription\"><span class=\"transcription-word-container\" ng-repeat=\"word in transcription.words\"><span class=\"transcription-word\" ng-class=\"{\'is-word-playing\': $ctrl.isPlaying(word.startTime, word.endTime, true)}\" data-starttime=\"{{ word.startTime }}\" data-endtime=\"{{ word.endTime }}\">{{word.text}}</span></span></p><p ng-if=\"$ctrl.islanguageTextDirectionRTL === \'rtl\'\" class=\"transcription-paragraph mousetrap rtl-right\" style=\"text-align: right;\" ng-click=\"$ctrl.playWordTime($event)\" dir=\"auto\" contenteditable=\"{{ !!(!$ctrl.isCurrentMediaLockByOtherUser && !$ctrl.isPublicPageView && ($ctrl.isTeamMember || $ctrl.isProjectOwner)) }}\" on-transcription-words-change=\"$ctrl.onTranscriptionWordsChange(words, transcription, refresh)\" on-transcription-words-create=\"$ctrl.onTranscriptionWordsCreate(words, transcription)\" on-transcription-words-remove=\"$ctrl.onTranscriptionWordsRemove(words, previousWords, transcription)\" transcription-row-disabled=\"$ctrl.isCurrentMediaLockByOtherUser || $ctrl.isPublicPageView || (!$ctrl.isTeamMember && !$ctrl.isProjectOwner)\" transcription-row=\"transcription\"><span class=\"transcription-word-container\" ng-repeat=\"word in transcription.words\"><span class=\"transcription-word\" ng-class=\"{\'is-word-playing\': $ctrl.isPlaying(word.startTime, word.endTime, true)}\" data-starttime=\"{{ word.startTime }}\" data-endtime=\"{{ word.endTime }}\">{{word.text}}</span></span></p></div></div><div class=\"simon-typing-image-container\" ng-if=\"$ctrl.isCurrentMediaTranscribing()\"><div class=\"transcribing-message-simon-typing\"><div><strong>Transcription in progress and your transcript will be ready soon!</strong></div><br><div><span>In the meantime, start a new transcription.</span></div></div><img class=\"img-responsive\" ng-class=\"{\'no-transcriptions\': !$ctrl.transcriptions.length}\" src=\"./img/simon_type_02_large.gif\" alt=\"\"></div></div><div class=\"transcriptions-list\" ng-if=\"$ctrl.isCurrentMediaTranslating()\"><div class=\"simon-typing-image-container\"><div class=\"transcribing-message-simon-typing\"><div><strong>Translation is progress and your translated transcript will be ready soon!</strong></div><br><div><span>In the meantime, start a new transcription.</span></div></div><img class=\"img-responsive\" ng-class=\"{\'no-transcriptions\': !$ctrl.transcriptions.length}\" src=\"./img/simon_type_02_large.gif\" alt=\"\"></div></div></div><div class=\"failed-project-description\" ng-if=\"$ctrl.currentMedia.status === \'failed\'\">This file encountered an error in transcription. Please contact support.</div><div class=\"go-to-transcript-container\"><a class=\"pull-left\" ng-click=\"$ctrl.goToPreviousTranscriptFile()\" ng-if=\"$ctrl.getCurrentMediaIndex() > 0\">Go to the previous transcript</a><a class=\"pull-right\" ng-click=\"$ctrl.goToNextTranscriptFile()\" ng-if=\"$ctrl.medias.length > 1 && $ctrl.getCurrentMediaIndex() < $ctrl.medias.length - 1\">Go to the next transcript</a></div></div></div></div><a id=\"bottom\"></a><script type=\"text/ng-template\" id=\"annotationPopoverTemplate.html\"><div class=\"form-group annotation\">\n            <label>Note</label>\n            <label-input ng-model=\"$ctrl.currentTranscription.annotation\"\n                         save-callback=\"$ctrl.saveAnnotation\"\n                         parameter-save-callback=\"$ctrl.currentTranscription\"\n                         label-type=\"\'textarea\'\"\n                         hide-label=\"true\"\n                         is-initial-mode-in-edit=\"true\"\n                         cancel-callback=\"$ctrl.cancelAnnotation\"\n                         class=\"\">\n            </label-input>\n        </div></script><script type=\"text/ng-template\" id=\"readOnlyAnnotationPopoverTemplate.html\"><div class=\"annotation\">\n            <div class=\"read-only-annotation\">\n                <span ng-bind-html=\"$ctrl.currentTranscription.annotation | linkyWithHtml : \'_blank\'\"> </span>\n            </div>\n        </div></script><script type=\"text/ng-template\" id=\"timecodePopoverTemplate.html\"><div class=\"form-group annotation\">\n            <label>Frame Rate</label>\n\n            <select class=\"form-control\"\n                    name=\"multipleSelect\"\n                    id=\"multipleSelect\"\n                    ng-options=\"frameRateOption for frameRateOption in $ctrl.frameRateOptions\"\n                    ng-model=\"$ctrl.currentMedia.fps\">\n            </select>\n            <div class=\"frame-rate-checkbox-container ss-checkbox checkbox checkbox-primary\">\n                <input type=\"checkbox\" ng-model=\"$ctrl.applyFrameRateToAllProject\" id=\"checkboxApplyFrameRateToAll\">\n                <label class=\"ss-label frame-rate-all-label\" for=\"checkboxApplyFrameRateToAll\">\n                    <span class=\"frame-rate-all-text\">Apply frame rate to all files in this project.</span>\n                </label>\n            </div>\n\n            <label>Start Timecode (HH:MM:SS{{$ctrl.getFrameSeparatorString()}}FF)</label>\n            <time-input ng-model=\"$ctrl.mediaTimecode\"\n                         save-callback=\"$ctrl.saveMedia\"\n                         frame-separator-string=\"{{ $ctrl.getFrameSeparatorString() }}\"\n                         parameter-save-callback=\"$ctrl.currentMedia\"\n                         cancel-callback=\"$ctrl.cancelTimecode\"\n                         max-frame=\"$ctrl.currentMedia.fps\">\n            </time-input>\n        </div></script><script type=\"text/ng-template\" id=\"speakerTemplate.html\"><span ng-if=\"!$ctrl.isCurrentMediaLockByOtherUser && !$ctrl.isPublicPageView\">\n        <input auto-focus=\"transcription.isSpeakerMenuOpen\"\n               ng-blur=\"$ctrl.addSpeakerOnBlur($event, $ctrl.currentTranscription)\"\n               ng-keypress=\"$ctrl.speakerOnKeyPress($event, $ctrl.currentTranscription)\"\n               maxlength=\"25\"\n               placeholder=\"Add Speaker\"\n               class=\"new-speaker-input\"\n               ng-model=\"$ctrl.newSpeaker.name\"/>\n        <table class=\"speaker-table\">\n            <tr ng-if=\"$ctrl.currentTranscription.speaker\">\n                <td class=\"speaker-initials-td\" ng-click=\"$ctrl.unSelectSpeakerFromRow($ctrl.currentTranscription)\">\n                    <div class=\"speaker-initials\" ng-style=\"$ctrl.getSpeakerCssStyle(speaker)\">\n                        >\n                    </div>\n                </td>\n                <td>\n                    (No Speaker)\n                </td>\n            </tr>\n            <tr ng-repeat=\"speaker in $ctrl.speakers track by speaker.id\">\n                <td class=\"speaker-initials-td\" ng-click=\"$ctrl.setTranscriptionSpeaker($ctrl.currentTranscription, speaker)\">\n                    <div class=\"speaker-initials\" ng-style=\"$ctrl.getSpeakerCssStyle(speaker)\">\n                        {{ speaker.name | initials }}\n                    </div>\n                </td>\n                <td>\n                    <input ng-model-options=\"{ debounce: 350 }\"\n                           maxlength=\"25\"\n                           ng-keypress=\"$ctrl.onEnterWhileUpdating($event, $ctrl.currentTranscription)\"\n                           ng-change=\"$ctrl.updateMediaSpeaker(speaker)\"\n                           ng-model=\"speaker.name\"/>\n                </td>\n            </tr>\n        </table>\n      </span>\n\n      <span ng-if=\"$ctrl.isCurrentMediaLockByOtherUser || $ctrl.isPublicPageView\">\n        <table class=\"speaker-table\">\n          <tr ng-if=\"$ctrl.currentTranscription.speaker\">\n            <td>\n              {{ $ctrl.currentTranscription.speaker.name }}\n            </td>\n          </tr>\n        </table>\n      </span></script></div>");
$templateCache.put("components/simon-header/simon-header.component.html","<nav class=\"main-header navbar navbar-default navbar-fixed-top first-main-header\" ng-class=\"{\'with-user-dropdown-open\': $ctrl.userDropDownIsOpen}\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"navbar-header\"><div class=\"logo-header-container\"><animated-logo ng-if=\"!$ctrl.whitelabel\" logo-href=\"{{ $ctrl.logoLinkHref || \'/\' }}\"></animated-logo><plain-logo ng-if=\"$ctrl.whitelabel\" logo-href=\"{{ $ctrl.logoLinkHref || \'/\' }}\"></plain-logo></div></div><div id=\"navbar\" class=\"\"><ul class=\"nav navbar-nav navbar-right\" ng-if=\"$ctrl.user\"><li><ng-transclude></ng-transclude></li><li ng-show=\"$ctrl.user\" class=\"dropdown\" uib-dropdown is-open=\"$ctrl.userDropDownIsOpen\"><a class=\"dropdown-toggle user-dropdown-toggle\" uib-dropdown-toggle role=\"button\" aria-haspopup=\"true\" aria-expanded=\"false\"><img ng-src=\"{{ $ctrl.getAvatarPath() }}\" alt=\"user\" class=\"user\"><span class=\"caret\"></span></a><ul class=\"dropdown-menu\" uib-dropdown-menu><li><div class=\"wrapper-list\"><h3>{{ $ctrl.user.fullName }}</h3></div></li><li class=\"common-link {{ menuItem.classAttribute }}\" ng-repeat=\"menuItem in $ctrl.menuItemList\"><a ng-click=\"$ctrl.onMenuItemClick({name: menuItem.name})\" type=\"button\"><i ng-if=\"menuItem.iconClass\" class=\"{{ menuItem.iconClass }}\" aria-hidden=\"true\"></i>{{ menuItem.displayName }}</a></li><li class=\"common-link\"><a ng-click=\"$ctrl.logout()\">Log out</a></li></ul></li></ul><ul class=\"nav navbar-nav navbar-right\" ng-if=\"!$ctrl.user\"><li class=\"signin-header-link\"><a ng-click=\"$ctrl.onLogin()\" target=\"{{ $ctrl.inIframe() ? \'_blank\' : \'_self\' }}\">Sign In</a></li></ul></div></div></div></div></nav>");
$templateCache.put("components/wave-surfer/wave-surfer.component.html","<div class=\"wave-form-wrapper\" tooltip-follow-cursor=\"$ctrl.getPointedTime($percentage)\"><div class=\"generic-overlay wave-form-overlay\" ng-style=\"$ctrl.waveFormOverlayStyle\" ng-if=\"!$ctrl.isLoaded\"><i class=\"fa fa-spinner fa-spin spin-normal\"></i></div><div class=\"wave-form-container\" ng-style=\"$ctrl.waveFormContainerStyle\" id=\"waveFormForTranscription\"><div class=\"display-time current-time\">{{ $ctrl.getCurrentTime() }}</div><div class=\"display-time remaining-time\">- {{ $ctrl.getRemainingTime() }}</div></div></div>");
$templateCache.put("directives/label-input/label-input.directive.html","<div class=\"textarea-c hide-label\" ng-show=\"hideLabel && labelType == \'textarea\'\"><textarea ng-blur=\"autoSave()\" auto-focus=\"isEditing\" class=\"form-control\" ng-model=\"ngModel\">\n    </textarea><a class=\"label-input-btn label-input-btn-cancel pull-right\" ng-click=\"cancel();\"><span class=\"fa fa-times-circle\"></span></a><a class=\"label-input-btn label-input-btn-ok pull-right\" ng-click=\"ok();\"><span class=\"fa fa-check-circle\"></span></a></div><div class=\"text-c not-hide-label\" ng-show=\"labelType != \'textarea\' && !hideLabel\"><input auto-focus=\"isEditing\" type=\"text\" placeholder=\"My Empty Project\" ng-model=\"ngModel\" ng-class=\"{\'project-editing-name\':isEditing}\" ng-show=\"isEditing\"><h1 ng-hide=\"isEditing\" title=\"{{ ngModel }}\" ng-click=\"edit();\">{{ngModel}}</h1><a ng-click=\"edit();\" ng-hide=\"isEditing\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></a><a class=\"label-input-btn label-input-btn-ok\" ng-click=\"ok();\" ng-show=\"isEditing\"><span class=\"fa fa-check-circle\"></span></a><a class=\"label-input-btn label-input-btn-cancel\" ng-click=\"cancel();\" ng-show=\"isEditing\"><span class=\"fa fa-times-circle\"></span></a></div><div class=\"textarea-c not-hide-label\" ng-show=\"labelType == \'textarea\' && !hideLabel\"><textarea ng-blur=\"autoSave()\" auto-focus=\"isEditing\" class=\"form-control\" placeholder=\"My Empty Project\" ng-model=\"ngModel\" ng-class=\"{\'textarea-editing\':isEditing}\" ng-click=\"edit();\">\n    </textarea><div class=\"row\"><div class=\"col-xs-12\"><a class=\"pull-right label-input-btn label-input-btn-cancel\" ng-click=\"cancel();\" ng-show=\"isEditing\"><span class=\"fa fa-times-circle\"></span></a><a class=\"pull-right label-input-btn label-input-btn-ok\" ng-click=\"ok();\" ng-show=\"isEditing\"><span class=\"fa fa-check-circle\"></span></a></div></div></div>");}]);